<template>
  <v-container
    class="twilio-whatsapp-shell textoPoppins pa-0"
    fluid
    @keydown.ctrl="abrirPegar"
  >
    <v-card class="twilio-whatsapp-app elevation-6">
      <v-row class="ma-0 fill-height twilio-whatsapp-row">
        <!-- LISTA -->
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-sidebar"
          :class="{ 'twilio-rh-sidebar-chat': isMobileLayout && chat }"
        >
          <div class="wa-sidebar-header twilio-rh-sidebar-header">
            <div class="d-flex align-center twilio-rh-header-title">
              <v-avatar color="#00a884" size="42">
                <v-icon color="white">mdi-whatsapp</v-icon>
              </v-avatar>
              <div class="ml-3 overflow-hidden">
                <div class="wa-title">TWILIO RH</div>
                <div class="wa-subtitle">
                  {{ filterChats.length }} contactos
                  <span v-if="filtroReclutador && !filtroReclutador.todos"> · {{ filtroReclutador.nombre }}</span>
                </div>
              </div>
            </div>
            <div class="d-flex align-center flex-shrink-0">
              <v-tooltip v-if="puedeDescargarJsonRh" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!allChats.length"
                    @click="descargarUltimos100Json"
                  >
                    <v-icon color="#54656f">mdi-download</v-icon>
                  </v-btn>
                </template>
                <span>Descargar los últimos 100 contactos en JSON</span>
              </v-tooltip>
              <v-tooltip v-if="esAdminRh" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!chatsSeleccionados.length"
                    @click="abrirReasignacionMasiva"
                  >
                    <v-badge
                      :value="chatsSeleccionados.length > 0"
                      :content="chatsSeleccionados.length"
                      color="#00a884"
                      overlap
                    >
                      <v-icon :color="chatsSeleccionados.length ? '#00a884' : '#adb5bd'">mdi-account-switch</v-icon>
                    </v-badge>
                  </v-btn>
                </template>
                <span>
                  {{ chatsSeleccionados.length
                    ? ('Reasignar ' + chatsSeleccionados.length + ' seleccionado' + (chatsSeleccionados.length === 1 ? '' : 's'))
                    : 'Selecciona chats en la lista para reasignar' }}
                </span>
              </v-tooltip>
              <v-menu bottom offset-y>
                <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: onTip, attrs: attrsTip }">
                      <v-btn
                        icon
                        small
                        v-bind="{ ...attrsMenu, ...attrsTip }"
                        v-on="{ ...onMenu, ...onTip }"
                      >
                        <v-icon :color="filtroReclutador && !filtroReclutador.todos ? '#00a884' : '#54656f'">mdi-account-switch-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Filtrar chats por reclutador</span>
                  </v-tooltip>
                </template>
                <v-list dense class="twilio-rh-reclutadores-menu">
                  <v-list-item
                    v-for="item in menuReclutadores"
                    :key="'rec-' + (item.todos ? 'todos' : (item.sinAsignar ? 'sin' : item.iderp))"
                    @click="seleccionarFiltroReclutador(item)"
                  >
                    <v-list-item-icon class="mr-2">
                      <v-icon :color="reclutadorMenuActivo(item) ? '#00a884' : '#8696a0'">mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="py-1">
                      <v-list-item-title class="text-caption text-truncate">{{ item.nombre }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action class="my-0 ml-2 flex-row align-center" style="min-width: auto;">
                      <v-avatar size="16" color="green" class="mr-1">
                        <v-icon x-small dark>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ item.verdes || 0 }}</span>
                      <v-avatar size="16" color="yellow darken-1" class="mr-1">
                        <v-icon x-small>mdi-clock</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ item.amarillos || 0 }}</span>
                      <v-avatar size="16" color="blue" class="mr-1">
                        <v-icon x-small dark>mdi-message</v-icon>
                      </v-avatar>
                      <span class="text-caption mr-2">{{ item.sinResponder || 0 }}</span>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="d-inline-flex align-center">
                            <v-avatar size="16" :color="item.horaSinContestarColor || 'grey'" class="mr-1">
                              <v-icon x-small dark>mdi-message-clock</v-icon>
                            </v-avatar>
                            <span class="text-caption text-no-wrap" :class="item.horaSinContestarClase">{{ item.horaSinContestar || '—' }}</span>
                          </span>
                        </template>
                        <span>Hora del último sin responder. Verde: 10 min o menos. Rojo: más de 10 min.</span>
                      </v-tooltip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="abrirReporteVacante">
                    <v-icon color="#54656f">mdi-chart-box-outline</v-icon>
                  </v-btn>
                </template>
                <span>Reporte por vacante</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="abrirHorariosEntrevista">
                    <v-icon color="#54656f">mdi-calendar-clock</v-icon>
                  </v-btn>
                </template>
                <span>Horarios de entrevista</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" @click="recargarChats()">
                    <v-icon color="#54656f">mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar conversaciones</span>
              </v-tooltip>
            </div>
          </div>

          <div
            class="twilio-rh-list-stack"
            :class="{ 'wa-panel-hidden': isMobileLayout && chat }"
          >
          <div class="wa-search-panel">
            <v-text-field
              :readonly="filterChats ? false : true"
              v-model="buscarUsuario"
              hide-details
              dense
              solo
              flat
              clearable
              rounded
              :autofocus="buscarUsuarioActive"
              prepend-inner-icon="mdi-magnify"
              placeholder="Buscar o iniciar un chat"
              class="wa-search"
            ></v-text-field>

            <div class="wa-filter-row wa-filter-row--stacked">
              <v-select
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="itemsFiltroVacante"
                label="Vacante"
                v-model="filtroVacante"
                item-value="value"
                item-text="text"
              />
              <v-select
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="itemsFiltroEtapa"
                label="Etapa"
                v-model="filtroEtapa"
                item-value="value"
                item-text="text"
              />
              <v-select
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="itemsFiltroEstatus"
                label="Estatus"
                v-model="filtroEstatus"
                item-value="value"
                item-text="text"
              />
              <v-select
                class="wa-select wa-incompletos-select"
                dense
                hide-details
                solo
                flat
                rounded
                :items="itemsFiltroAsignacion"
                label="Responsable"
                v-model="filtroAsignacion"
                item-value="value"
                item-text="text"
              />
            </div>

            <div class="wa-filter-row">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroVistos"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroVistos"
                    :rounded="filtroVistos"
                    :color="filtroVistos ? 'grey darken-2' : 'white'"
                    :dark="filtroVistos"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroVistos = !filtroVistos"
                  >
                    <v-icon :color="filtroVistos ? 'white' : 'grey darken-2'">mdi-message-bulleted-off</v-icon>
                    <span v-if="filtroVistos" class="text-caption font-weight-bold">Sin respuesta</span>
                  </v-btn>
                </template>
                <span>Chats sin responder</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroHumana"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroHumana"
                    :rounded="filtroHumana"
                    :color="filtroHumana ? 'teal darken-1' : 'white'"
                    :dark="filtroHumana"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroHumana = !filtroHumana"
                  >
                    <v-icon :color="filtroHumana ? 'white' : 'teal darken-1'">mdi-message-text</v-icon>
                    <span v-if="filtroHumana" class="text-caption font-weight-bold">Requiere humana</span>
                  </v-btn>
                </template>
                <span>Chats que el bot pasó a reclutadora</span>
              </v-tooltip>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="!!etiquetaCaso"
                    class="wa-filter-btn"
                    :fab="!etiquetaCaso"
                    :rounded="!!etiquetaCaso"
                    :color="etiquetaCaso ? (etiquetaCaso.color || 'grey darken-2') : 'white'"
                    :dark="!!etiquetaCaso"
                    v-bind="attrs"
                    v-on="etiquetaCaso ? {} : on"
                    @click="onClickBotonEtiquetaCaso"
                  >
                    <v-icon :color="etiquetaCaso ? 'white' : 'grey darken-2'">mdi-label</v-icon>
                    <span v-if="etiquetaCaso" class="text-caption font-weight-bold ml-1">{{ etiquetaCaso.text }}</span>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item v-for="item in etiquetasMenu" :key="'ec-' + item.id" @click="seleccionarEtiquetaCaso(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-label</v-icon>
                      {{ item.text }} ({{ item.count || 0 }})
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-menu bottom offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tipOn, attrs: tipAttrs }">
                      <v-btn
                        small
                        :depressed="!!filtroTiempo"
                        class="wa-filter-btn"
                        :fab="!filtroTiempo"
                        :rounded="!!filtroTiempo"
                        :color="filtroTiempo ? (filtroTiempo.color || 'grey darken-2') : 'white'"
                        :dark="!!filtroTiempo"
                        v-bind="{ ...attrs, ...tipAttrs }"
                        v-on="filtroTiempo ? tipOn : { ...on, ...tipOn }"
                        @click="onClickBotonTiempo"
                      >
                        <v-icon :color="filtroTiempo ? 'white' : 'grey darken-2'">mdi-clock</v-icon>
                        <span v-if="filtroTiempo" class="text-caption font-weight-bold ml-1">{{ filtroTiempo.text }}</span>
                      </v-btn>
                    </template>
                    <span>Horas o días desde su último mensaje.</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item v-for="(item, index) in tiempos" :key="'t-' + index" @click="seleccionarFiltroTiempo(item)">
                    <v-list-item-title class="text-caption">
                      <v-icon small :color="item.color">mdi-clock</v-icon>
                      {{ item.text }} {{ item.count != null ? '(' + item.count + ')' : '' }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    :depressed="filtroCita"
                    class="wa-filter-btn"
                    :class="{ 'px-3': true }"
                    :fab="!filtroCita"
                    :rounded="filtroCita"
                    :color="filtroCita ? 'indigo darken-1' : 'white'"
                    :dark="filtroCita"
                    v-bind="attrs"
                    v-on="on"
                    @click="filtroCita = !filtroCita"
                  >
                    <v-icon :color="filtroCita ? 'white' : 'indigo darken-1'">mdi-calendar-check</v-icon>
                    <span v-if="filtroCita" class="text-caption font-weight-bold">Cita</span>
                  </v-btn>
                </template>
                <span>Chats con cita de entrevista</span>
              </v-tooltip>

              <v-btn
                rounded
                class="wa-filter-clear"
                @click="limpiarFiltros"
              >
                Todos
              </v-btn>
            </div>
          </div>

          <div id="preguntas" ref="chatList" class="wa-chat-list">
            <div
              v-if="!filterChats.length"
              class="pa-6 text-center"
            >
              <v-icon size="48" color="#d1d7db">mdi-account-search-outline</v-icon>
              <div class="text-caption grey--text mt-2">
                Sin conversaciones RH todavía. Los mensajes del Sandbox aparecerán aquí.
              </div>
            </div>

            <div
              v-for="(chatW, i) in filterChats"
              :key="chatW.usuario || i"
              :class="['wa-contact', { 'wa-contact-active': chatEstaActivo(chatW), 'wa-contact-checked': chatEstaSeleccionado(chatW) }]"
              :ref="chatEstaActivo(chatW) ? 'chatActivoFila' : null"
              @click="verChat(chatW)"
            >
              <div
                v-if="esAdminRh"
                class="wa-contact-check"
                @click.stop="toggleSeleccionChat(chatW)"
              >
                <v-icon
                  :color="chatEstaSeleccionado(chatW) ? '#00a884' : '#8696a0'"
                  size="22"
                >
                  {{ chatEstaSeleccionado(chatW) ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline' }}
                </v-icon>
              </div>
              <div class="wa-contact-avatar-wrap">
                <v-avatar color="#00a884" size="48">
                  <v-icon color="white">mdi-briefcase-account</v-icon>
                </v-avatar>
              </div>

              <div class="wa-contact-body">
                <div class="wa-contact-top">
                  <div class="wa-contact-name">
                    <v-icon
                      small
                      class="mr-1"
                      v-if="etiquetaCatalogoChat(chatW)"
                      :color="etiquetaCatalogoChat(chatW).color"
                    >mdi-label</v-icon>
                    {{ tituloListaChat(chatW) }}
                  </div>
                  <div class="wa-contact-time">{{ horaChat(chatW) }}</div>
                </div>
                <div class="wa-contact-middle" v-if="subtituloListaChat(chatW)">
                  {{ subtituloListaChat(chatW) }}
                </div>

                <div class="wa-contact-bottom">
                  <div class="wa-last-message">
                    <v-icon small class="mr-1" v-if="chatW.mio" color="#8696a0">mdi-check-all</v-icon>
                    {{ resumenMensaje(chatW) }}
                  </div>
                  <div class="wa-contact-badges">
                    <v-chip
                      v-if="etiquetaTiempoChat(chatW)"
                      x-small
                      label
                      dark
                      class="wa-time-chip"
                      :color="etiquetaTiempoChat(chatW).color"
                      :title="etiquetaTiempoChat(chatW).title"
                    >
                      {{ etiquetaTiempoChat(chatW).text }}
                      <v-icon x-small right>mdi-clock</v-icon>
                    </v-chip>
                    <span v-if="chatW.sinleer > 0 || chatW.mio == 0" class="wa-unread">
                      {{ chatW.sinleer > 0 ? chatW.sinleer : 1 }}
                    </span>
                  </div>
                </div>
                <div class="wa-rh-chips-row">
                  <span
                    v-if="etiquetaAsignadaChat(chatW)"
                    class="wa-rh-chip wa-rh-chip--solid"
                    :style="{ background: etiquetaAsignadaChat(chatW).color }"
                    :title="etiquetaAsignadaChat(chatW).previa ? (fichaPreviaChat(chatW) || etiquetaAsignadaChat(chatW).text) : etiquetaAsignadaChat(chatW).text"
                  >{{ etiquetaAsignadaChat(chatW).text }}</span>
                  <span
                    v-if="chatW.cv_filtro_texto"
                    class="wa-rh-chip"
                    :class="chatW.cv_filtro === 'aplica' ? 'wa-rh-chip--ok' : 'wa-rh-chip--bad'"
                    title="Filtro del CV vs la vacante (≥70%). No es el estatus de Entrevistas."
                  >{{ chatW.cv_filtro_texto }}</span>
                  <span
                    v-if="chatW.pendiente_revision"
                    class="wa-rh-chip wa-rh-chip--solid"
                    style="background: #F9A825"
                    title="El CV espera que RH elija sucursal o rechace"
                  >Pendiente de revisión</span>
                  <span
                    v-if="chatW.requiere_humana"
                    class="wa-rh-chip wa-rh-chip--warn"
                  >Requiere humana</span>
                  <span
                    v-if="chatW.match_estado === 'vinculado'"
                    class="wa-rh-chip wa-rh-chip--ok"
                  >Vinculado</span>
                  <span
                    v-else-if="chatW.match_estado === 'unico'"
                    class="wa-rh-chip wa-rh-chip--ok"
                  >Candidato</span>
                  <span
                    v-else-if="chatW.match_estado === 'varios'"
                    class="wa-rh-chip wa-rh-chip--warn"
                  >Varios</span>
                  <span
                    v-if="etiquetaEtapaChat(chatW)"
                    class="wa-rh-chip wa-rh-chip--muted"
                  >{{ etiquetaEtapaChat(chatW) }}</span>
                  <span
                    v-if="tieneCvChat(chatW)"
                    class="wa-rh-chip wa-rh-chip--ok"
                  >CV</span>
                  <span
                    v-if="chatW.entrevista"
                    class="wa-rh-chip"
                    :class="claseChipEntrevista(chatW.entrevista)"
                  >{{ chatW.entrevista.estatus_texto }}</span>
                  <span
                    v-else-if="chatW.match_estado === 'vinculado' || chatW.match_estado === 'unico'"
                    class="wa-rh-chip wa-rh-chip--muted"
                  >Sin cita</span>
                  <span
                    v-if="chatW.entrevista && chatW.entrevista.vistobueno_texto"
                    class="wa-rh-chip"
                    :class="claseChipTone(chatW.entrevista.vistobueno_tone)"
                  >{{ chatW.entrevista.vistobueno_texto }}</span>
                </div>
              </div>
            </div>

          </div>
          </div>
        </v-col>

        <!-- CONVERSACIÓN -->
        <v-col
          cols="12"
          sm="6"
          class="pa-0 twilio-whatsapp-conversation"
          :class="{ 'wa-panel-hidden': isMobileLayout && !chat }"
        >
          <div v-if="!chat" class="wa-empty-state">
            <v-icon size="96" color="#d1d7db">mdi-whatsapp</v-icon>
            <h2>Twilio RH</h2>
            <p>Selecciona un chat para ver la conversación.</p>
            <p class="text-caption grey--text">
              Diseño Unificado · Sandbox temporal RH
            </p>
          </div>

          <template v-else>
            <div class="wa-chat-header">
              <div class="wa-chat-header-left">
                <v-btn
                  v-if="isMobileLayout"
                  icon
                  small
                  class="wa-back-btn"
                  @click="cerrarChatMobile"
                >
                  <v-icon color="#54656f">mdi-arrow-left</v-icon>
                </v-btn>
                <v-avatar color="#00a884" size="40" class="wa-chat-avatar">
                  <v-icon color="white">mdi-briefcase-account</v-icon>
                </v-avatar>
                <div class="wa-chat-header-info">
                  <div class="wa-chat-name">
                    <v-icon
                      small
                      v-if="etiquetaCatalogoChat(chat)"
                      :color="etiquetaCatalogoChat(chat).color"
                    >mdi-label</v-icon>
                    {{ tituloContactoChat(chat) }}
                  </div>
                  <div class="wa-chat-meta">
                    <span v-if="nombreReclutadorChat(chat)">{{ nombreReclutadorChat(chat) }} · </span>
                    {{ telefonoListaChat(chat) }}
                    <span v-if="vacanteChatBanner"> · {{ vacanteChatBanner }}</span>
                    <span v-if="etiquetaEtapaChat(chat)"> · {{ etiquetaEtapaChat(chat) }}</span>
                    <span v-if="chat.entrevista"> · {{ chat.entrevista.estatus_texto }}</span>
                    <span v-else-if="matchEstadoChat === 'vinculado' || matchEstadoChat === 'unico'"> · Sin cita</span>
                    <span v-if="etiquetaCitaChat(chat)"> · {{ etiquetaCitaChat(chat) }}</span>
                  </div>
                </div>
              </div>

              <div class="wa-chat-actions">
                <v-tooltip v-if="puedeReiniciarProcesoRh" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      :disabled="reiniciandoProceso"
                      @click="pedirConfirmar('reiniciar')"
                    >
                      <v-icon color="#c62828">mdi-restart</v-icon>
                    </v-btn>
                  </template>
                  <span>Reiniciar proceso</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="abrirDialogCandidato"
                    >
                      <v-icon :color="matchEstadoChat !== 'ninguno' ? '#00a884' : '#54656f'">mdi-account</v-icon>
                    </v-btn>
                  </template>
                  <span>Datos del candidato</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="abrirReasignarRh">
                      <v-icon color="#54656f">mdi-account-switch</v-icon>
                    </v-btn>
                  </template>
                  <span>Reasignar contacto</span>
                </v-tooltip>
                <v-menu top offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on">
                      <v-icon color="#54656f">mdi-label-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="item in etiquetasCasoManuales"
                      :key="'hdr-' + item.id"
                      @click="asignarEtiquetaRh(item)"
                    >
                      <v-list-item-title class="text-caption">
                        <v-icon small :color="item.color">mdi-label</v-icon>
                        {{ item.text || item.etiqueta }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" :disabled="!idFichaChat" @click="abrirNotasFicha">
                      <v-icon color="#54656f">mdi-comment-plus-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Comentarios de la ficha</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="dialogDescrip = true">
                      <v-icon color="#54656f">mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <span>Etiquetas</span>
                </v-tooltip>
              </div>
            </div>

            <v-alert
              v-if="!numeroTwilioRh"
              dense
              text
              type="warning"
              class="ma-2"
            >
              No hay sender RH configurado. La carga/envío de mensajes se habilitará con la nueva línea.
            </v-alert>

            <section class="wa-chat-area">
              <v-container
                id="scroll-target"
                class="wa-messages-scroll overflow-y-auto elevation-0"
                @scroll="onScroll"
              >
                <MensajesWppTwilio
                  class="messages-chat elevation-0"
                  id="mensajesChat"
                  :whatsappStyle="true"
                  :mensajes="mensajes"
                  :alumno="alumno"
                  :wha="wha"
                  :chat="chat"
                  :verTodosLosMensajes="verTodosLosMensajes"
                  :analysisIA="analysisIA"
                  :asignacion="asignacion"
                  :numeroTwilio="numeroTwilioRh"
                  endpoint-enviar="twilio-rh.enviar"
                  :modo-adjuntos-rh="true"
                  texto-ventana-cerrada="Hola, este contacto ya no puede recibir mensajes, debido a que la ventana de 24 horas se ha cerrado"
                  @validayGuardaMensajes="validayGuardaMensajesRh"
                  @analizar-cv="abrirAnalizarCv"
                  :chats="allChats"
                  @verChat="verChat"
                />
              </v-container>
            </section>
          </template>
              </v-col>
            </v-row>
    </v-card>

    <v-dialog v-model="dialogCandidato" max-width="520px" transition="dialog-transition">
      <v-card>
        <v-card-title class="subtitle-1">Candidato</v-card-title>
        <v-card-text class="black--text pt-2">
          <div v-if="!chat" class="twilio-rh-panel__empty">
            Selecciona un chat para ver si hay un candidato en formulario.
          </div>

          <template v-else-if="matchEstadoChat === 'ninguno'">
            <div class="d-flex align-center mb-2">
              <v-icon color="#8696a0" class="mr-2">mdi-account-off-outline</v-icon>
              <span>Sin candidato vinculado ni coincidencia de WhatsApp.</span>
            </div>
            <div class="text-caption grey--text">
              El número en el formulario debe coincidir en los últimos 10 dígitos. No se crea ficha desde aquí.
            </div>
          </template>

          <template v-else>
            <v-alert
              v-if="matchEstadoChat === 'varios'"
              dense
              text
              type="warning"
              class="mb-3"
            >
              Varios candidatos con el mismo teléfono. No se asignó uno solo.
            </v-alert>

            <div
              v-for="cand in candidatosDelChat"
              :key="cand.idformulario"
              class="twilio-rh-cand"
            >
              <v-text-field
                :value="nombreEditPorFolio[cand.idformulario]"
                label="Nombre del candidato"
                filled
                dense
                hide-details="auto"
                maxlength="120"
                class="mb-2"
                @input="setNombreEdit(cand.idformulario, $event)"
              />
            <v-btn 
              small 
                tile
                dark
                color="#00a884"
                class="mb-2"
                :loading="guardandoNombreId === cand.idformulario"
                :disabled="!puedeGuardarNombre(cand)"
                @click="guardarNombreCandidato(cand)"
              >
                Guardar nombre
            </v-btn>
              <div class="text-caption grey--text mb-2">Folio {{ cand.idformulario }}</div>
              <div class="twilio-rh-cand__row">
                <strong>Vacante:</strong>
                {{ cand.puesto || 'Sin vacante (puesto) asignada' }}
              </div>
            <v-btn 
                v-if="!estaVinculado(cand)"
                small
                tile
                outlined
                color="#00a884"
                class="mb-2 mr-2"
                :loading="guardandoVinculoId === cand.idformulario"
                @click="pedirConfirmar('vincular', cand)"
              >
                Vincular a este chat
              </v-btn>
              <v-chip
                v-else
                x-small
                class="mb-2 mr-2"
                color="#00a884"
                text-color="white"
              >Vinculado</v-chip>
              <div class="twilio-rh-cand__row" v-if="cand.departamento">{{ cand.departamento }}</div>
              <div class="twilio-rh-cand__row">{{ cand.numero_wa }}</div>
              <div class="twilio-rh-cand__row" v-if="cand.correo">{{ cand.correo }}</div>
              <div class="twilio-rh-cand__row">Etapa: {{ textoEtapaInbox(cand) }}</div>
              <div class="twilio-rh-cand__row" v-if="entrevistaDelChat">
                <strong>Entrevista:</strong>
                {{ entrevistaDelChat.estatus_texto }}
                <span v-if="etiquetaCitaChat(chat)"> · {{ etiquetaCitaChat(chat) }}</span>
              </div>
              <div class="twilio-rh-cand__row" v-else-if="estaVinculado(cand)">
                <strong>Entrevista:</strong> Sin cita
              </div>
              <div class="twilio-rh-chips mt-2" v-if="entrevistaDelChat">
                <v-chip
                  x-small
                  dark
                  :color="colorEstatusEntrevista(entrevistaDelChat.estatus)"
                >{{ entrevistaDelChat.estatus_texto }}</v-chip>
                <v-chip
                  x-small
                  class="ml-1"
                  :color="entrevistaDelChat.vistobueno === 1 ? 'green' : (entrevistaDelChat.vistobueno === 2 ? 'black' : 'grey')"
                  dark
                >{{ entrevistaDelChat.vistobueno_texto }}</v-chip>
                <v-chip
                  v-if="entrevistaDelChat.asistio"
                  x-small
                  class="ml-1"
                  color="green"
                  dark
                >Asistió</v-chip>
              </div>
              <div class="twilio-rh-cand__row" v-if="cand.tiene_cv">CV en ficha</div>
              <v-chip
                x-small
                class="mt-2"
                :color="Number(cand.finalizo) === 1 ? 'grey' : 'green'"
                text-color="white"
              >
                {{ Number(cand.finalizo) === 1 ? 'Cerrado' : 'Activo' }}
              </v-chip>
            </div>
          </template>
        </v-card-text>
        <v-card-actions class="twilio-rh-cand-actions flex-wrap">
          <v-btn
            v-if="chat && matchEstadoChat === 'vinculado'"
            text
            small
            color="orange darken-2"
            :loading="guardandoVinculoId === 'des'"
            @click="pedirConfirmar('desvincular')"
          >
            Desvincular
            </v-btn>
          <v-btn
            v-if="candidatoSeleccionado && candidatoSeleccionado.idformulario"
            text
            small
            color="orange darken-2"
            @click="abrirEntrevista"
          >
            Agendar cita
                </v-btn>
          <v-btn
            v-if="chat && matchEstadoChat !== 'ninguno'"
            text
            small
            color="#00a884"
            @click="abrirProspectosRh"
          >
            Prospectos RH
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text small color="#00a884" @click="dialogCandidato = false">Cerrar</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>

      <v-dialog v-model="dialogDescrip" max-width="500px" transition="dialog-transition">
        <v-card>
          <v-card-title primary-title>Etiquetas</v-card-title>
          <v-card-text class="black--text">
            <div v-for="(etiqueta, i) in etiquetasCaso" :key="'leg-' + i">
              <v-icon :color="etiqueta.color">mdi-label</v-icon>
              <b>{{ etiqueta.etiqueta || etiqueta.text }}</b>
              <template v-if="etiqueta.detalles">
                <br />
                {{ etiqueta.detalles }}
              </template>
              <br />
              <br />
              <v-divider></v-divider>
            </div>
            <div v-if="!(etiquetasCaso && etiquetasCaso.length)" class="text-caption">
              Sin catálogo de etiquetas.
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

    <v-dialog v-model="dialogReasignarRh" max-width="420px">
      <v-card>
        <v-card-title class="subtitle-1">
          {{ reasignacionMasiva ? ('Reasignar ' + chatsSeleccionados.length + ' contactos') : 'Reasignar contacto' }}
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="iderpReasignar"
            :items="reclutadorasRh"
            item-text="nombre"
            item-value="iderp"
            label="Reclutadora"
            filled
            dense
            hide-details
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogReasignarRh = false">Cancelar</v-btn>
          <v-btn color="#00a884" dark small :disabled="!iderpReasignar" :loading="guardandoReasignar" @click="guardarReasignarRh">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogNotasFicha" max-width="640px" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">Comentarios de la ficha</v-card-title>
        <v-card-text>
          <ComentariosFicha v-if="idFichaChat" :comentarios="comentariosFicha" @click="addComentarioFicha" />
          <div v-else class="text-caption">Este chat todavía no tiene ficha.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="#00a884" @click="dialogNotasFicha = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <MensajesPredeterminados
      :openDialogMensajes="openDialogMensajes"
      v-if="openDialogMensajes.estatus"
      :alumno="alumno"
    />

    <v-dialog v-model="dialogCvAnalizar" max-width="720px" scrollable transition="dialog-transition">
      <v-card>
        <v-card-title class="subtitle-1">
          Resumen del documento
          <v-spacer></v-spacer>
          <v-btn icon :disabled="cvAnalizando || cvGuardando" @click="cerrarAnalizarCv">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="black--text pt-1">
          <div class="text-caption grey--text mb-2">
            Adjunto interno
            <span v-if="cvIdmensajes"> · mensaje {{ cvIdmensajes }}</span>
          </div>
          <div v-if="esAnalisisCv && cvPuestoPostulacion" class="mb-3">
            <strong>Puesto al que se postula:</strong> {{ cvPuestoPostulacion }}
            </div>

          <v-alert v-if="cvResult && cvResult.from_cache" dense text type="success" class="mb-3">
            Resultado ya analizado (sin consumir tokens).
          </v-alert>
          <v-alert v-else-if="esAnalisisDocumento" dense text type="info" class="mb-3">
            Resumen automático del documento. La ficha y la cita se resuelven en el chat.
          </v-alert>
          <v-alert v-else dense text type="info" class="mb-3">
            Resumen automático del CV. La ficha se crea y, si coincide con el descriptor de la vacante, se proponen horarios por WhatsApp.
          </v-alert>
          <v-alert v-if="cvYaAplicado" dense outlined type="success" class="mb-3">
            Este adjunto ya se aplicó a la ficha.
          </v-alert>

          <v-progress-linear v-if="cvAnalizando" indeterminate color="#00a884" class="mb-3" />

          <v-alert v-if="cvError" dense outlined type="error" class="mb-3">
            {{ cvError }}
          </v-alert>

          <template v-else-if="esAnalisisDocumento && !cvAnalizando">
            <div class="text-caption grey--text mb-1">Resumen del documento</div>
            <v-simple-table dense class="mb-3">
              <tbody>
                <tr><th class="text-left">Tipo</th><td>{{ cvDocumento.tipo_documento || 'documento' }}</td></tr>
                <tr><th class="text-left">Asunto</th><td>{{ cvDocumento.asunto || '—' }}</td></tr>
                <tr>
                  <th class="text-left">Fechas</th>
                  <td>{{ (cvDocumento.fechas && cvDocumento.fechas.length) ? cvDocumento.fechas.join(', ') : '—' }}</td>
                </tr>
                <tr v-for="(campo, i) in (cvDocumento.campos || [])" :key="'docc-' + i">
                  <th class="text-left">{{ campo.etiqueta || 'Campo' }}</th>
                  <td>{{ campo.valor || '—' }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-textarea
              v-model="cvResumen"
              label="Resumen revisado"
              outlined
              dense
              rows="5"
              auto-grow
              hide-details="auto"
              class="mb-3"
              disabled
            />
            <v-alert v-if="cvMatchEstado === 'unico'" dense text type="success" class="mb-2">
              Folio {{ cvIdformulario }} — la ficha se actualiza sola al analizar el CV en el chat.
            </v-alert>
          </template>

          <v-alert
            v-else-if="cvResult && cvResult.ok && !esAnalisisDocumento && !cvDraftUtilizable && !cvAnalizando"
            dense
            outlined
            type="warning"
            class="mb-3"
          >
            Este archivo no parece un currículum utilizable (escaneado, vacío o no es un CV).
            No se guardará nada en la ficha.
          </v-alert>

          <v-sheet v-if="cvDescriptor" outlined rounded class="pa-3 mb-3">
            <div class="d-flex align-center mb-2">
              <v-chip small label :color="colorPuntajeCv" dark>
                {{ cvDescriptor.etiqueta || '0/0' }}
              </v-chip>
              <span class="ml-3 subtitle-2">
                {{ cvDescriptor.match
                  ? 'El CV cumple el perfil. Elige la sucursal para continuar o rechaza.'
                  : 'El CV no cumple todo el perfil. Revisa los criterios y decide.' }}
              </span>
            </div>
            <div class="d-flex flex-wrap mb-2">
              <span class="leyenda-puntaje mr-3"><i class="leyenda-dot green"></i> Verde: cumple 70% o más</span>
              <span class="leyenda-puntaje mr-3"><i class="leyenda-dot orange"></i> Naranja: cumple del 40% al 69%</span>
              <span class="leyenda-puntaje"><i class="leyenda-dot red"></i> Rojo: cumple menos del 40%</span>
            </div>
            <div v-if="cvDescriptor.motivo" class="text-body-2 mb-2">{{ cvDescriptor.motivo }}</div>
            <v-list dense class="py-0">
              <v-list-item
                v-for="(criterio, i) in (cvDescriptor.criterios || [])"
                :key="'crit-' + i"
                class="px-0"
              >
                <v-list-item-icon class="mr-2 my-1">
                  <v-icon small :color="criterio.cumple ? 'green' : 'red'">
                    {{ criterio.cumple ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content class="py-1">
                  <v-list-item-title class="text-body-2 wrap-criterio">
                    {{ criterio.requisito }}<span v-if="criterio.detalle" class="font-weight-bold"> · {{ criterio.detalle }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle v-if="criterio.respondido && criterio.respuesta" class="text-caption wrap-criterio">
                    Respondió en el chat: «{{ criterio.respuesta }}»
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-alert
              v-if="cvRevision && cvRevision.pregunta_pendiente && !cvDecisionYaTomada"
              dense
              text
              type="info"
              class="mt-2 mb-0"
            >
              El chatbot está preguntando: «{{ cvRevision.pregunta_pendiente }}». Las respuestas suben el puntaje.
            </v-alert>
            <v-alert
              v-else-if="cvRevision && cvRevision.cerrada"
              dense
              text
              type="warning"
              class="mt-2 mb-0"
            >
              El chatbot cerró el proceso por la edad del postulante.
            </v-alert>
            <div v-if="puedeDecidirCv" class="text-caption grey--text mt-1">
              Elige la sucursal para continuar o rechaza. Rechazar envía el cierre. En Recepción, una edad fuera de 18 a 24 años cierra el proceso.
            </div>
          </v-sheet>

          <template v-if="cvResult && cvResult.ok && esAnalisisCv && cvDraftUtilizable">
            <v-alert
              v-for="(w, i) in (cvResult.warnings || [])"
              :key="'cvw-' + i"
              dense
              text
              type="warning"
              class="mb-2"
            >
              {{ w }}
            </v-alert>

            <div class="text-caption grey--text mb-1">Datos extraídos del CV (solo consulta).</div>
            <v-text-field
              v-model="cvEdit.nombre_completo"
              label="Nombre completo"
              outlined
              dense
              hide-details
              class="mb-2"
              disabled
            />
            <v-text-field
              v-model="cvEdit.correo"
              label="Correo"
              outlined
              dense
              hide-details
              class="mb-2"
              disabled
            />
            <v-text-field
              v-model="cvEdit.edad"
              label="Edad"
              type="number"
              outlined
              dense
              hide-details
              class="mb-2"
              disabled
            />
            <v-text-field
              v-model="cvEdit.direccion"
              label="Dirección"
              outlined
              dense
              hide-details
              class="mb-2"
              disabled
            />
            <v-sheet v-if="cvSucursalesItems.length" outlined rounded class="pa-3 mb-3">
              <div class="subtitle-2 mb-1">Sucursales más cercanas</div>
              <div v-if="cvTextoSucursalesAviso" class="text-caption grey--text mb-1">{{ cvTextoSucursalesAviso }}</div>
              <v-radio-group
                v-model="cvSucursalElegida"
                hide-details
                class="mt-0"
                :disabled="!puedeDecidirCv"
              >
                <v-radio
                  v-for="(suc, i) in cvSucursalesItems"
                  :key="'suc-' + suc.idplantel"
                  :value="suc.idplantel"
                  class="mb-2"
                >
                  <template v-slot:label>
                    <div>
                      <div class="text-body-2 black--text">{{ letraInciso(i) }}) {{ suc.plantel }}</div>
                      <div class="text-caption grey--text text--darken-1">{{ textoTiempoSucursal(suc) }}</div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-sheet>
            <div class="text-caption grey--text mb-1">¿Domina el inglés? (como en Prospectos RH)</div>
            <v-radio-group v-model="cvEdit.dominio_ingles" row hide-details class="mt-0 mb-2" disabled>
              <v-radio label="Sí" :value="1"></v-radio>
              <v-radio label="No" :value="0"></v-radio>
            </v-radio-group>
            <v-text-field
              :value="cvTelefonoCv || '—'"
              label="Teléfono en el CV (solo comentario)"
              outlined
              dense
              readonly
              hide-details
              class="mb-2"
            />
            <v-alert dense text type="info" class="mb-3">
              {{ cvNotaTelefono }}
            </v-alert>
            <v-simple-table dense class="mb-3">
              <tbody>
                <tr><th class="text-left">Vacante (no se cambia)</th><td>{{ cvPuestoPostulacion || '—' }}</td></tr>
              </tbody>
            </v-simple-table>

            <v-textarea
              v-model="cvResumen"
              label="Resumen revisado"
              outlined
              dense
              rows="6"
              auto-grow
              hide-details="auto"
              class="mb-3"
              disabled
            />

            <v-alert v-if="cvMatchEstado === 'unico'" dense text type="success" class="mb-2">
              Folio {{ cvIdformulario }} — la ficha se actualiza sola al analizar el CV en el chat.
            </v-alert>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="puedeDecidirCv"
            outlined
            color="red darken-1"
            :disabled="cvDecidiendo"
            @click="decidirCv('rechazar')"
          >Rechazar CV</v-btn>
          <v-btn
            v-if="puedeDecidirCv"
            color="#00a884"
            class="white--text"
            :disabled="cvDecidiendo || (cvSucursalesItems.length > 0 && !cvSucursalElegida)"
            @click="decidirCv('aceptar')"
          >{{ cvSucursalesItems.length ? 'Elegir sucursal y continuar' : 'Aceptar CV' }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn text :disabled="cvAnalizando || cvGuardando || cvDecidiendo" @click="cerrarAnalizarCv">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirm" max-width="400px">
      <v-card>
        <v-card-title class="subtitle-1">{{ confirmTitulo }}</v-card-title>
        <v-card-text class="black--text">{{ confirmTexto }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogConfirm = false">Cancelar</v-btn>
          <v-btn
            text
            :color="confirmAccion === 'reiniciar' ? 'red darken-1' : '#00a884'"
            :loading="reiniciandoProceso"
            @click="ejecutarConfirmacion"
          >{{ confirmAccion === 'reiniciar' ? 'Reiniciar' : 'Confirmar' }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

      <Alerta v-if="respuestaAlerta" :parametros="parametros" />
      <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import MensajesWppTwilio from '@/components/whatsapp/MensajesTwilioWpp.vue'
import MensajesPredeterminados from '@/components/whatsapp/MensajesPredeterminados.vue'
import ComentariosFicha from '@/components/formularios/Comentarios.vue'

import {
  fechaUltimoMensajeMs,
  formatFechaMexicoFront,
  aplicarHoraSinContestar,
  colorHoraSinContestar,
  colorHoraSinContestarGrupo,
  claseTextoHoraSinContestar,
  maxHoraSinContestarDeMap
} from '@/utils/twilioFechaMexico'
import validarErrores from '@/mixins/validarErrores'
import mixinWhatsApp from '@/mixins/mixinWhatsApp'
import mixinEstatusWha from '@/mixins/mixinEstatusWha'

/** Línea RH (tablas usuarios_/mensajes_5218119030746). */
const NUMERO_TWILIO_RH = 'whatsapp:+5218119030746'

const ETAPAS_RH = [
  { etapa: 0, text: 'En contacto' },
  { etapa: 1, text: '1era entrevista' },
  { etapa: 2, text: 'Prueba Técnica' },
  { etapa: 3, text: 'Prueba psicológica' },
  { etapa: 4, text: 'Entrevista Técnica' },
  { etapa: 5, text: 'Inv. Laboral' },
  { etapa: 6, text: 'Exámenes Médicos' },
  { etapa: 7, text: 'Firma de contrato' },
  { etapa: 8, text: 'Inducción' },
  { etapa: 9, text: 'Capacitación' },
  { etapa: 10, text: 'Incorporación' },
]

const ESTATUS_CITA_RH = [
  { id: 7, text: 'En proceso' },
  { id: 1, text: 'Aplica' },
  { id: 2, text: 'No aplica' },
  { id: 3, text: 'No se presentó' },
  { id: 4, text: 'Segunda entrevista' },
  { id: 5, text: 'Citado para training' },
  { id: 6, text: 'Abandonó proceso' },
  { id: 8, text: 'Contratada' },
]

export default {
  components: {
    Alerta,
    carga,
    MensajesWppTwilio,
    MensajesPredeterminados,
    ComentariosFicha,
  },

  mixins: [validarErrores, mixinEstatusWha, mixinWhatsApp],

  data: () => ({
    dialogDescrip: false,
    dialogCandidato: false,
    nombreEditPorFolio: {},
    guardandoNombreId: null,
    guardandoVinculoId: null,
    dialogCvAnalizar: false,
    cvAnalizando: false,
    cvDecidiendo: false,
    cvDecisionLocal: '',
    cvSucursalElegida: null,
    cvGuardando: false,
    cvIdmensajes: null,
    cvResult: null,
    cvError: '',
    cvResumen: '',
    cvIdformulario: null,
    cvTelefonoCv: '',
    cvEdit: {
      nombre_completo: '',
      correo: '',
      edad: '',
      direccion: '',
      dominio_ingles: null,
    },
    analysisIA: {},
    parametros: {
      dialogError: false,
      mensaje: '',
      color: '',
    },
    respuestaAlerta: false,
    cargar: false,
    buscarUsuario: '',
    buscarUsuarioActive: true,
    alumno: null,
    mensajes: [],
    chat: null,
    wha: null,
    verTodosLosMensajes: 0,
    asignacion: null,
    offsetTop: 0,
    limite: 30,
    filtroVistos: false,
    filtroHumana: false,
    filtroCita: false,
    filtroTiempo: null,
    etiquetaCaso: null,
    etiquetasCaso: [
      { id: 100, text: 'Ficha previa', color: '#5e35b1', previa: true },
      { id: 101, text: 'Nuevo', color: '#E040FB' },
      { id: 102, text: 'Con cita agendada y confirmada', color: '#00897B' },
      { id: 103, text: 'No aplica', color: '#6D4C41' },
      { id: 104, text: 'No interesado', color: '#546E7A' },
      { id: 105, text: 'No asistió a entrevista', color: '#EF6C00' },
      { id: 106, text: 'No contesta', color: '#78909C' },
      {
        id: 107,
        text: 'Pendiente de revisión',
        color: '#F9A825',
        revision: true,
        detalles: 'El postulante ya respondió y el CV espera que RH elija sucursal o rechace. Se calcula sola; no se asigna a mano.',
      },
    ],
    esAdminRh: false,
    dialogReasignarRh: false,
    dialogNotasFicha: false,
    reclutadorasRh: [],
    filtroReclutador: null,
    chatsSeleccionados: [],
    reasignacionMasiva: false,
    iderpReasignar: null,
    guardandoReasignar: false,
    comentariosFicha: [],
    nuevoComentarioFicha: '',
    filtroVacante: '',
    filtroEtapa: '',
    filtroEstatus: '',
    filtroAsignacion: 'todas',
    vacantesCartera: [],
    dialogConfirm: false,
    reiniciandoProceso: false,
    confirmAccion: null,
    confirmCand: null,
    escuela: 1,
    openDialogMensajes: {
      estatus: false,
    },
    /** Línea RH temporal (Sandbox). No usar Unificado/Fast/Agente. */
    numeroTwilioRh: NUMERO_TWILIO_RH,
    /** Evita initialize() del mixin (twilio.chats de ventas con twilio undefined → .replace). */
    skipMixinWhatsAppInit: true,
    allChats: [],
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    puedeDescargarJsonRh () {
      const idpuesto = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto)
      return idpuesto === 11 || idpuesto === 12
    },

    puedeReiniciarProcesoRh () {
      return this.puedeDescargarJsonRh
    },

    filterChats () {
      // Solo chats RH locales; no reutilizar store de Unificado/Fast (ventas).
      let chats = this.allChats || []

      if (this.buscarUsuario) {
        const q = String(this.buscarUsuario).toLowerCase()
        chats = chats.filter((el) => {
          const usuario = el.usuario ? String(el.usuario).toLowerCase() : ''
          const nombre = el.nombre ? String(el.nombre).toLowerCase() : ''
          const folio = el.folio ? String(el.folio).toLowerCase() : ''
          const cand = el.candidato && el.candidato.nombre_completo
            ? String(el.candidato.nombre_completo).toLowerCase()
            : ''
          const idf = el.candidato && el.candidato.idformulario
            ? String(el.candidato.idformulario)
            : ''
          const rec = el.reclutador && el.reclutador.nombre
            ? String(el.reclutador.nombre).toLowerCase()
            : ''
          return usuario.indexOf(q) !== -1
            || nombre.indexOf(q) !== -1
            || folio.indexOf(q) !== -1
            || cand.indexOf(q) !== -1
            || idf.indexOf(q) !== -1
            || rec.indexOf(q) !== -1
        })
      }

      chats = chats.slice().sort((a, b) => {
        return fechaUltimoMensajeMs(b) - fechaUltimoMensajeMs(a)
      })

      if (this.filtroVistos) {
        chats = chats.filter((el) => el.mio == 0)
      }

      if (this.filtroHumana) {
        chats = chats.filter((el) => el.requiere_humana)
      }

      if (this.etiquetaCaso) {
        if (this.etiquetaCaso.previa || this.etiquetaCaso.id === 'previa') {
          chats = chats.filter((el) => this.fichaPreviaChat(el) || Number(el.idetiquetas) === 100)
        } else if (this.etiquetaCaso.revision || this.etiquetaCaso.id === 'revision') {
          chats = chats.filter((el) => el.pendiente_revision)
        } else {
          const id = Number(this.etiquetaCaso.idetiquetas || this.etiquetaCaso.id)
          chats = chats.filter((el) => Number(el.idetiquetas) === id)
        }
      }

      if (this.filtroCita) {
        chats = chats.filter((el) => el.entrevista && el.entrevista.identrevistas)
      }

      if (this.filtroTiempo) {
        const id = Number(this.filtroTiempo.idtiempos)
        if (id === 1) chats = chats.filter((el) => Number(el.tiemporestante) > 2)
        else if (id === 2) chats = chats.filter((el) => Number(el.tiemporestante) > 0 && Number(el.tiemporestante) <= 2)
        else if (id === 3) chats = chats.filter((el) => Number(el.tiemporestante) <= 0)
      }

      if (this.filtroVacante) {
        const idp = Number(this.filtroVacante)
        chats = chats.filter((el) => this.idsPuestoChat(el).indexOf(idp) !== -1)
      }

      if (this.filtroEtapa !== '' && this.filtroEtapa != null) {
        const et = Number(this.filtroEtapa)
        chats = chats.filter((el) => {
          const c = el.candidato
          return c && Number(c.etapa) === et
        })
      }

      if (this.filtroEstatus === 'sin') {
        chats = chats.filter((el) => !el.entrevista)
      } else if (this.filtroEstatus !== '' && this.filtroEstatus != null) {
        const est = Number(this.filtroEstatus)
        chats = chats.filter((el) => el.entrevista && Number(el.entrevista.estatus) === est)
      }

      if (this.filtroAsignacion === 'sin') {
        chats = chats.filter((el) => !this.responsableChat(el))
      } else if (this.filtroAsignacion === 'mias') {
        const yo = Number(this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp)
        chats = chats.filter((el) => el.vinculo && Number(el.vinculo.iderp_responsable) === yo)
      } else if (this.filtroAsignacion === 'con') {
        chats = chats.filter((el) => this.responsableChat(el))
      }

      if (this.filtroReclutador && this.filtroReclutador.sinAsignar) {
        chats = chats.filter((el) => !this.responsableChat(el))
      } else if (this.filtroReclutador && Number(this.filtroReclutador.iderp) > 0) {
        const idRec = Number(this.filtroReclutador.iderp)
        chats = chats.filter((el) => el.vinculo && Number(el.vinculo.iderp_responsable) === idRec)
      }

      return chats
    },

    menuReclutadores () {
      const chats = this.allChats || []
      const vacio = () => ({
        verdes: 0,
        amarillos: 0,
        sinResponder: 0,
        count: 0,
        horaSinContestarMs: 0,
        horaSinContestar: '—'
      })
      const map = { 0: vacio() }
      const nombres = {}
      for (let i = 0; i < chats.length; i++) {
        const chat = chats[i]
        const id = chat.vinculo ? Number(chat.vinculo.iderp_responsable) : 0
        const key = id > 0 ? id : 0
        if (!map[key]) map[key] = vacio()
        const entry = map[key]
        entry.count += 1
        const t = Number(chat.tiemporestante)
        if (t > 2) entry.verdes += 1
        else if (t > 0 && t <= 2) entry.amarillos += 1
        if (t > 0 && Number(chat.mio) === 0) entry.sinResponder += 1
        aplicarHoraSinContestar(entry, chat)
        const rec = chat.reclutador
        if (key && rec && rec.nombre && !nombres[key]) nombres[key] = this.formatearNombreRh(rec.nombre)
      }
      const catalogo = this.reclutadorasRh || []
      for (let i = 0; i < catalogo.length; i++) {
        const id = Number(catalogo[i].iderp)
        if (id && catalogo[i].nombre) nombres[id] = this.formatearNombreRh(catalogo[i].nombre)
        if (id && !map[id]) map[id] = vacio()
      }

      const todos = vacio()
      Object.keys(map).forEach((key) => {
        const entry = map[key]
        todos.verdes += entry.verdes
        todos.amarillos += entry.amarillos
        todos.sinResponder += entry.sinResponder
        todos.count += entry.count
      })
      const horaTodos = maxHoraSinContestarDeMap(map)
      todos.horaSinContestarMs = horaTodos.horaSinContestarTodosMs
      todos.horaSinContestar = horaTodos.horaSinContestarTodos

      const pintar = (entry) => {
        const color = colorHoraSinContestar(entry.horaSinContestarMs)
        return {
          ...entry,
          horaSinContestarColor: color,
          horaSinContestarClase: claseTextoHoraSinContestar(color)
        }
      }
      const colorTodos = colorHoraSinContestarGrupo(map)
      const items = [
        {
          iderp: 0,
          nombre: 'Todos',
          todos: true,
          ...pintar(todos),
          horaSinContestarColor: colorTodos,
          horaSinContestarClase: claseTextoHoraSinContestar(colorTodos)
        },
        { iderp: 0, nombre: 'Sin reclutador', sinAsignar: true, ...pintar(map[0]) }
      ]
      const ids = Object.keys(nombres)
      const filas = []
      for (let i = 0; i < ids.length; i++) {
        const id = Number(ids[i])
        filas.push({ iderp: id, nombre: nombres[id], ...pintar(map[id] || vacio()) })
      }
      filas.sort((a, b) => String(a.nombre).localeCompare(String(b.nombre)))
      return items.concat(filas)
    },

    mostrarCargarMas () {
      return this.filterChats.length > this.limite
    },

    isMobileLayout () {
      return this.$vuetify.breakpoint.smAndDown
    },

    matchEstadoChat () {
      return (this.chat && this.chat.match_estado) || 'ninguno'
    },

    candidatoSeleccionado () {
      return (this.chat && this.chat.candidato) || null
    },

    entrevistaDelChat () {
      return (this.chat && this.chat.entrevista) || null
    },

    candidatosDelChat () {
      return (this.chat && this.chat.candidatos) || []
    },

    colorBtnCandidato () {
      if (this.matchEstadoChat === 'vinculado') return '#00a884'
      if (this.matchEstadoChat === 'unico') return '#00a884'
      if (this.matchEstadoChat === 'varios') return 'orange darken-2'
      return 'grey lighten-2'
    },

    idFichaChat () {
      const c = this.chat && this.chat.candidato
      const v = this.chat && this.chat.vinculo
      return Number((c && c.idformulario) || (v && v.idformulario) || 0)
    },

    vacanteChatBanner () {
      if (this.matchEstadoChat !== 'unico' && this.matchEstadoChat !== 'vinculado') return ''
      if (!this.candidatoSeleccionado) return ''
      return this.candidatoSeleccionado.puesto || ''
    },

    itemsFiltroVacante () {
      const items = [{ value: '', text: 'Todas las vacantes' }]
      const byId = {}
      const add = (id, nombre) => {
        const n = Number(id)
        if (!n) return
        const text = String(nombre || '').trim()
        if (!byId[n]) {
          byId[n] = { value: n, text: text || ('Puesto ' + n) }
          return
        }
        if (text) byId[n].text = text
      }
      const rows = this.vacantesCartera || []
      for (let i = 0; i < rows.length; i++) {
        add(rows[i].idpuesto, rows[i].puesto)
      }
      const chats = this.allChats || []
      for (let i = 0; i < chats.length; i++) {
        const c = chats[i] && chats[i].candidato
        if (c && c.puesto_interes) add(c.puesto_interes, c.puesto)
        const list = (chats[i] && chats[i].candidatos) || []
        for (let j = 0; j < list.length; j++) {
          if (list[j] && list[j].puesto_interes) {
            add(list[j].puesto_interes, list[j].puesto)
          }
        }
      }
      const ids = Object.keys(byId)
      for (let i = 0; i < ids.length; i++) items.push(byId[ids[i]])
      return items
    },

    itemsFiltroEtapa () {
      const items = [{ value: '', text: 'Todas las etapas' }]
      for (let i = 0; i < ETAPAS_RH.length; i++) {
        items.push({ value: ETAPAS_RH[i].etapa, text: ETAPAS_RH[i].text })
      }
      return items
    },

    itemsFiltroEstatus () {
      const items = [
        { value: '', text: 'Todos los estatus' },
        { value: 'sin', text: 'Sin cita' },
      ]
      for (let i = 0; i < ESTATUS_CITA_RH.length; i++) {
        items.push({ value: ESTATUS_CITA_RH[i].id, text: ESTATUS_CITA_RH[i].text })
      }
      return items
    },

    itemsFiltroAsignacion () {
      return [
        { value: 'todas', text: 'Todas' },
        { value: 'sin', text: 'Sin asignar' },
        { value: 'mias', text: 'Asignadas a mí' },
        { value: 'con', text: 'Con responsable' },
      ]
    },

    etiquetasCasoManuales () {
      return (this.etiquetasCaso || []).filter((et) => !et.revision)
    },

    etiquetasMenu () {
      const chats = this.allChats || []
      return (this.etiquetasCaso || []).map((et) => {
        let count = 0
        for (let j = 0; j < chats.length; j++) {
          if (et.previa) {
            if (this.fichaPreviaChat(chats[j]) || Number(chats[j].idetiquetas) === et.id) count++
          } else if (et.revision) {
            if (chats[j].pendiente_revision) count++
          } else if (Number(chats[j].idetiquetas) === et.id) {
            count++
          }
        }
        return {
          id: et.previa ? 'previa' : (et.revision ? 'revision' : et.id),
          idetiquetas: et.id,
          text: et.text,
          color: et.color,
          count: count,
          previa: Boolean(et.previa),
          revision: Boolean(et.revision),
        }
      })
    },

    confirmTitulo () {
      if (this.confirmAccion === 'vincular') return 'Vincular candidato'
      if (this.confirmAccion === 'desvincular') return 'Desvincular chat'
      if (this.confirmAccion === 'asignar') return 'Asignar chat'
      if (this.confirmAccion === 'reiniciar') return 'Reiniciar proceso'
      return 'Confirmar'
    },

    confirmTexto () {
      if (this.confirmAccion === 'vincular') {
        const folio = this.confirmCand && this.confirmCand.idformulario
        return '¿Vincular este chat al folio ' + folio + '? No se crea una ficha nueva.'
      }
      if (this.confirmAccion === 'desvincular') {
        return '¿Quitar el candidato vinculado de este chat? El folio no se borra.'
      }
      if (this.confirmAccion === 'asignar') {
        return '¿Asignarte como responsable de este chat? Debes tener la vacante en cartera.'
      }
      if (this.confirmAccion === 'reiniciar') {
        return 'Se borra este chat, el vínculo, el análisis del CV, la entrevista y los comentarios. La ficha de este WhatsApp pasa a papelera. Cuando la persona vuelva a escribir, el chatbot empieza desde el primer mensaje.'
      }
      return ''
    },

    cvDraft () {
      return (this.cvResult && this.cvResult.draft) || {}
    },

    cvDocumento () {
      return (this.cvResult && this.cvResult.documento) || {}
    },

    esAnalisisCv () {
      return Boolean(this.cvResult && this.cvResult.ok && this.cvResult.tipo === 'cv')
    },

    esAnalisisDocumento () {
      return Boolean(this.cvResult && this.cvResult.ok && this.cvResult.tipo === 'documento')
    },

    cvMatch () {
      return (this.cvResult && this.cvResult.match) || { estado: 'ninguno', candidatos: [], candidato: null }
    },

    cvDescriptor () {
      const d = this.cvResult && this.cvResult.cv_descriptor
      if (!d || !Array.isArray(d.criterios)) return null
      return d
    },

    colorPuntajeCv () {
      const d = this.cvDescriptor
      const total = Number(d && d.total) || (d && d.criterios && d.criterios.length) || 0
      const cumple = Number(d && d.cumple)
      const n = Number.isFinite(cumple) ? cumple : (d.criterios || []).filter((row) => row.cumple).length
      if (!total) return 'red'
      const p = n / total
      if (p >= 0.7) return 'green'
      if (p >= 0.4) return 'orange'
      return 'red'
    },

    cvDecisionYaTomada () {
      if (this.cvDecisionLocal) return true
      const rows = this.mensajes || []
      const id = Number(this.cvIdmensajes)
      let desde = rows.findIndex((row) => id && Number(row && row.idmensajes) === id)
      if (desde < 0) {
        desde = rows.findIndex((row) => (
          Number(row && row.mio) === 1
          && String((row && row.mensaje) || '').includes('revisando si tu perfil')
        ))
      }
      const inicio = desde >= 0 ? desde + 1 : rows.length
      for (let i = inicio; i < rows.length; i++) {
        if (Number(rows[i] && rows[i].mio) !== 1) continue
        const t = String(rows[i].mensaje || '')
        if (
          t.includes('decidimos continuar el proceso con otros perfiles')
          || t.includes('registré tu postulación')
          || t.includes('Tu perfil coincide con la vacante')
          || t.includes('quedó agendada')
          || t.includes('La entrevista es en:')
        ) return true
      }
      return false
    },

    puedeDecidirCv () {
      if (this.cvAnalizando || this.cvDecidiendo || this.cvDecisionYaTomada) return false
      if (!this.cvDescriptor) return false
      if (this.cvRevision && this.cvRevision.cerrada) return false
      return Boolean(this.cvIdmensajes)
    },

    cvRevision () {
      return (this.cvResult && this.cvResult.revision_cv) || null
    },

    cvSucursalesItems () {
      const s = this.cvResult && this.cvResult.sucursales_cercanas
      return (s && Array.isArray(s.items)) ? s.items : []
    },

    cvTextoSucursalesAviso () {
      const s = this.cvResult && this.cvResult.sucursales_cercanas
      if (!s || s.ok) return s && s.unica ? 'La vacante solo tiene esta sucursal.' : ''
      if (s.motivo === 'sin_direccion') return 'Sin dirección: el chatbot se la pide al postulante. Mientras, se muestran las sucursales de la vacante.'
      if (s.motivo === 'direccion_no_encontrada') return 'No se encontró la dirección en el mapa; se muestran las sucursales de la vacante sin tiempo.'
      return 'No se pudo calcular el tiempo; se muestran las sucursales de la vacante.'
    },

    cvMatchEstado () {
      return this.cvMatch.estado || 'ninguno'
    },

    cvCandidatosSelect () {
      return (this.cvMatch.candidatos || []).map((c) => ({
        idformulario: c.idformulario,
        label: (c.nombre_completo || 'Sin nombre') + ' · folio ' + c.idformulario + (c.puesto ? ' · ' + c.puesto : ''),
      }))
    },

    cvFichaDestino () {
      if (this.cvMatchEstado === 'unico') return this.cvMatch.candidato || null
      if (this.cvMatchEstado === 'varios' && this.cvIdformulario) {
        return (this.cvMatch.candidatos || []).find((c) => Number(c.idformulario) === Number(this.cvIdformulario)) || null
      }
      return null
    },

    cvPuestoPostulacion () {
      const ficha = this.cvFichaDestino
      if (ficha && ficha.puesto) return ficha.puesto
      if (this.matchEstadoChat === 'unico' && this.candidatoSeleccionado && this.candidatoSeleccionado.puesto) {
        return this.candidatoSeleccionado.puesto
      }
      return ''
    },

    cvDraftUtilizable () {
      return this.draftCvUtilizable(this.cvDraft)
    },

    cvWaChat10 () {
      const chat = this.chat && this.chat.usuario
      const ficha = this.cvFichaDestino && this.cvFichaDestino.numero_wa
      const raw = ficha || chat || ''
      return String(raw).replace(/\D/g, '').slice(-10)
    },

    cvNotaTelefono () {
      const cv = String(this.cvTelefonoCv || '').replace(/\D/g, '').slice(-10)
      const wa = this.cvWaChat10
      if (!cv) return 'Teléfono en CV: no se detectó. No se modificará el WhatsApp de la ficha.'
      if (!wa) return 'Teléfono en CV: ' + cv + '. No hay WhatsApp del chat para comparar. No se escribirá en la ficha.'
      if (cv === wa) return 'Teléfono en CV (' + cv + '): coincide con el WhatsApp al que se le está escribiendo. No se modifica numero_wa.'
      return 'Teléfono en CV (' + cv + '): es distinto del WhatsApp del chat (' + wa + '). Solo se guarda en el comentario.'
    },

    cvYaAplicado () {
      if (this.cvResult && this.cvResult.ya_aplicado) return true
      const folio = Number(this.cvIdformulario)
      const list = (this.cvResult && this.cvResult.ya_aplicado_folios) || []
      if (!folio) return list.length > 0
      return list.some((id) => Number(id) === folio) || list.length > 0
    },

    puedeGuardarResumenCv () {
      if (this.cvAnalizando || this.cvGuardando || this.cvYaAplicado) return false
      if (!this.esAnalisisCv || !this.cvDraftUtilizable) return false
      if (!String(this.cvResumen || '').trim()) return false
      if (!this.cvIdmensajes) return false
      if (this.cvMatchEstado === 'ninguno') return false
      if (this.cvMatchEstado === 'varios' && !this.cvIdformulario) return false
      if (this.cvMatchEstado === 'unico' && !this.cvIdformulario) return false
      return true
    },

    puedeGuardarDocumento () {
      if (this.cvAnalizando || this.cvGuardando || this.cvYaAplicado) return false
      if (!this.esAnalisisDocumento) return false
      if (!String(this.cvResumen || '').trim()) return false
      if (!this.cvIdmensajes) return false
      if (this.cvMatchEstado === 'ninguno') return false
      if (!this.cvIdformulario) return false
      return true
    },

    puedeGuardarAdjunto () {
      return this.esAnalisisDocumento ? this.puedeGuardarDocumento : this.puedeGuardarResumenCv
    },
  },

  watch: {
    '$route.query.wa' () {
      this.abrirChatDesdeQuery()
    },
    '$route.query.humana' () {
      this.aplicarFiltroHumanaQuery()
    },
  },

  async created () {
    this.crearTemplateSonido()
    this.guardarConversacionesUnif([])
    this.allChats = []
    this.cargarReclutadorasRh()
    await this.recargarChats()
    this.cargarVacantesCartera()
    this.aplicarFiltroHumanaQuery()
    this.abrirChatDesdeQuery()
  },

  methods: {
    ...mapActions('twilio', ['guardarConversacionesUnif']),

    onScroll (e) {
      if (e && e.target) {
      this.offsetTop = e.target.scrollTop
      }
    },

    limpiarFiltros () {
      this.filtroVistos = false
      this.filtroHumana = false
      this.etiquetaCaso = null
      this.filtroCita = false
      this.buscarUsuario = ''
      this.filtroVacante = ''
      this.filtroEtapa = ''
      this.filtroEstatus = ''
      this.filtroAsignacion = 'todas'
      this.filtroReclutador = null
      this.filtroTiempo = null
    },

    onClickBotonTiempo () {
      if (this.filtroTiempo) this.filtroTiempo = null
    },

    etiquetaAsignadaChat (chat) {
      if (!chat) return null
      const id = Number(chat.idetiquetas)
      const manual = (this.etiquetasCaso || []).find((et) => et.id === id)
      if (manual) return manual
      if (this.fichaPreviaChat(chat)) {
        return (this.etiquetasCaso || []).find((et) => et.previa) || null
      }
      return null
    },

    etiquetaCatalogoChat (chat) {
      const et = this.etiquetaAsignadaChat(chat)
      if (!et) return null
      return { color: et.color, text: et.text }
    },

    asignarEtiquetaRh (item) {
      if (!this.chat || !item) return
      const id = item.idetiquetas != null ? Number(item.idetiquetas) : Number(item.id)
      if (!id) return
      this.$set(this.chat, 'idetiquetas', id)
      this.allChats = (this.allChats || []).map((c) => (
        c.usuario === this.chat.usuario ? Object.assign({}, c, { idetiquetas: id }) : c
      ))
      const usuario = this.getdatosUsuarioERPERP || {}
      this.$http.post('twilio.etiqueta', {
        twilio: this.numeroTwilioRh,
        usuario: this.chat.idusuarios_wpp || this.chat.usuario,
        etiqueta: id,
        usuario_cambio: {
          usuario_erp: usuario.iderp,
          trabajador_id: usuario.id_trabajador,
          usuario: usuario.nombre_completo,
        },
      }).catch((error) => {
        this.validarError(error)
      })
    },

    onClickBotonEtiquetaCaso () {
      if (this.etiquetaCaso) this.etiquetaCaso = null
    },

    seleccionarEtiquetaCaso (item) {
      if (this.etiquetaCaso && this.etiquetaCaso.id === item.id) {
        this.etiquetaCaso = null
        return
      }
      this.etiquetaCaso = item
    },

    seleccionarFiltroTiempo (item) {
      if (this.filtroTiempo && this.filtroTiempo.idtiempos === item.idtiempos) {
        this.filtroTiempo = null
        return
      }
      this.filtroTiempo = item
    },

    fichaPreviaChat (chat) {
      const f = chat && chat.candidato
      const raw = f && f.fecha_creacion
      if (!raw) return ''
      const ts = new Date(raw).getTime()
      if (!ts || Number.isNaN(ts)) return ''
      const dias = Math.floor((Date.now() - ts) / 86400000)
      if (dias < 365) return ''
      const anios = Math.max(1, Math.floor(dias / 365))
      const folio = f.idformulario ? 'Folio ' + f.idformulario + '. ' : ''
      return folio + 'Postulación de hace ' + anios + (anios === 1 ? ' año' : ' años') + '. Pasó directo con reclutadora; no se abrió ficha nueva.'
    },

    etiquetaTiempoChat (chat) {
      if (!chat || chat.tiemporestante == null || chat.tiemporestante === '') return null
      const horas = Number(chat.tiemporestante)
      if (Number.isNaN(horas)) return null
      if (horas > 2) {
        return { text: String(Math.floor(horas)), color: 'green', title: 'Horas que faltan para cumplir 24 h desde el último mensaje del postulante' }
      }
      if (horas > 0) {
        return { text: String(Math.ceil(horas)), color: 'yellow', title: 'Faltan pocas horas para cumplir 24 h sin mensaje del postulante' }
      }
      const dias = Math.max(1, Math.floor((24 - horas) / 24))
      return {
        text: dias + 'd',
        color: dias >= 3 ? 'red' : 'orange',
        title: dias === 1 ? 'Ya pasaron 24 h (1 día)' : 'Ya pasaron ' + dias + ' días'
      }
    },

    abrirPegar () {},

    abrirAjustesMensajes () {
      this.openDialogMensajes.estatus = true
    },

    abrirReporteVacante () {
      this.$router.push({ path: '/twilio-rh-reporte' })
    },

    abrirHorariosEntrevista () {
      this.$router.push({ path: '/twilio-rh-horarios' })
    },

    abrirDialogCandidato () {
      return this.recargarChats().then(() => {
        this.syncNombresEditCandidato()
        this.dialogCandidato = true
      })
    },

    setNombreEdit (idformulario, valor) {
      this.$set(this.nombreEditPorFolio, idformulario, valor)
    },

    syncNombresEditCandidato () {
      const map = {}
      const list = this.candidatosDelChat || []
      for (let i = 0; i < list.length; i++) {
        const c = list[i]
        map[c.idformulario] = c.nombre_completo || ''
      }
      this.nombreEditPorFolio = map
    },

    puedeGuardarNombre (cand) {
      if (!cand || this.guardandoNombreId) return false
      const actual = String(cand.nombre_completo || '').trim()
      const editado = String(this.nombreEditPorFolio[cand.idformulario] || '').trim()
      return editado.length > 0 && editado !== actual
    },

    aplicarNombreEnChats (idformulario, nombre) {
      const id = Number(idformulario)
      const patch = (row) => {
        if (!row) return
        if (row.candidato && Number(row.candidato.idformulario) === id) {
          this.$set(row.candidato, 'nombre_completo', nombre)
        }
        const list = row.candidatos || []
        for (let i = 0; i < list.length; i++) {
          if (Number(list[i].idformulario) === id) {
            this.$set(list[i], 'nombre_completo', nombre)
          }
        }
      }
      patch(this.chat)
      const chats = this.allChats || []
      for (let i = 0; i < chats.length; i++) patch(chats[i])
    },

    estaVinculado (cand) {
      const id = cand && Number(cand.idformulario)
      const v = this.chat && this.chat.vinculo
      return Boolean(id && v && Number(v.idformulario) === id)
    },

    textoEtapa (etapa) {
      if (etapa == null || etapa === '') return '—'
      const n = Number(etapa)
      for (let i = 0; i < ETAPAS_RH.length; i++) {
        if (ETAPAS_RH[i].etapa === n) return ETAPAS_RH[i].text
      }
      return String(etapa)
    },

    textoEtapaInbox (cand) {
      if (!cand || cand.etapa == null || cand.etapa === '') return '—'
      return this.textoEtapa(cand.etapa)
    },

    etiquetaEtapaChat (row) {
      if (row && row.etapa_texto) return row.etapa_texto
      const c = row && row.candidato
      if (!c || c.etapa == null) return ''
      if (Number(c.etapa) === 0) {
        const est = row.match_estado
        if (est === 'unico' || est === 'vinculado') return 'En contacto'
      }
      return this.textoEtapa(c.etapa)
    },

    etiquetaCitaChat (row) {
      const e = row && row.entrevista
      if (!e) return ''
      const f = e.fecha_cita ? String(e.fecha_cita).slice(0, 10) : ''
      const h = e.hora_cita || ''
      if (f && h) return 'Cita ' + f + ' ' + h
      if (f) return 'Cita ' + f
      return ''
    },

    claseChipTone (tone) {
      if (tone === 'ok') return 'wa-rh-chip--ok'
      if (tone === 'warn') return 'wa-rh-chip--warn'
      if (tone === 'bad') return 'wa-rh-chip--bad'
      if (tone === 'info') return 'wa-rh-chip--info'
      return 'wa-rh-chip--muted'
    },

    claseChipEntrevista (entrevista) {
      return this.claseChipTone(entrevista && entrevista.estatus_tone)
    },

    colorEstatusEntrevista (estatus) {
      const n = Number(estatus)
      if (n === 1 || n === 8) return 'green'
      if (n === 2 || n === 3) return 'red'
      if (n === 4) return 'yellow darken-2'
      if (n === 5) return 'orange'
      if (n === 6) return 'pink'
      if (n === 7) return 'blue'
      return 'grey'
    },

    tieneCvChat (row) {
      return Boolean(row && row.candidato && row.candidato.tiene_cv)
    },

    responsableChat (row) {
      return Boolean(row && row.vinculo && Number(row.vinculo.iderp_responsable) > 0)
    },

    idsPuestoChat (row) {
      const ids = []
      if (row && row.vinculo && Number(row.vinculo.idpuesto_proceso) > 0) {
        ids.push(Number(row.vinculo.idpuesto_proceso))
      }
      const list = (row && row.candidatos && row.candidatos.length)
        ? row.candidatos
        : (row && row.candidato ? [row.candidato] : [])
      for (let i = 0; i < list.length; i++) {
        const p = Number(list[i].puesto_interes)
        if (p) ids.push(p)
      }
      return ids
    },

    cargarVacantesCartera () {
      const iderp = this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp
      if (!iderp) {
        this.vacantesCartera = []
        return
      }
      this.$http.get('encargadas.get/' + iderp).then((response) => {
        const data = response.data || response.body || {}
        this.vacantesCartera = data.encargada || []
      }).catch(() => {
        this.vacantesCartera = []
      })
    },

    pedirConfirmar (accion, cand) {
      this.confirmAccion = accion
      this.confirmCand = cand || null
      this.dialogConfirm = true
    },

    ejecutarConfirmacion () {
      const accion = this.confirmAccion
      const cand = this.confirmCand
      this.dialogConfirm = false
      this.confirmAccion = null
      this.confirmCand = null
      if (accion === 'vincular') this.vincularCandidato(cand)
      if (accion === 'desvincular') this.desvincularCandidato()
      if (accion === 'asignar') this.asignarmeChat()
      if (accion === 'reiniciar') this.reiniciarProcesoChat()
    },

    reiniciarProcesoChat () {
      const chat = this.chat
      const id = chat && Number(chat.idusuarios_wpp)
      if (!id || this.reiniciandoProceso || !this.puedeReiniciarProcesoRh) return
      this.reiniciandoProceso = true
      this.$http.post('twilio-rh.reiniciar', { idusuarios_wpp: id }).then(() => {
        this.allChats = (this.allChats || []).filter((c) => Number(c.idusuarios_wpp) !== id)
        this.chat = null
        this.mensajes = []
        this.validarSuccess('Proceso reiniciado. Cuando vuelva a escribir, el chatbot empieza de nuevo.')
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.reiniciandoProceso = false
      })
    },

    recargarChatsRhTrasVinculo () {
      return this.recargarChats().then(() => {
        if (!this.chat || !this.chat.idusuarios_wpp) return
        const id = Number(this.chat.idusuarios_wpp)
        const actualizado = (this.allChats || []).find((c) => Number(c.idusuarios_wpp) === id)
        if (actualizado) this.chat = actualizado
        this.syncNombresEditCandidato()
      })
    },

    vincularCandidato (cand) {
      if (!this.chat || !cand) return
      this.guardandoVinculoId = cand.idformulario
      this.$http.post('twilio-rh.vincular', {
        idusuarios_wpp: this.chat.idusuarios_wpp,
        usuario: this.chat.usuario,
        idformulario: cand.idformulario,
      }).then(() => {
        this.validarSuccess('Candidato vinculado')
        return this.recargarChatsRhTrasVinculo()
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.guardandoVinculoId = null
      })
    },

    desvincularCandidato () {
      if (!this.chat) return
      this.guardandoVinculoId = 'des'
      this.$http.post('twilio-rh.desvincular', {
        idusuarios_wpp: this.chat.idusuarios_wpp,
        usuario: this.chat.usuario,
      }).then(() => {
        this.validarSuccess('Chat desvinculado')
        return this.recargarChatsRhTrasVinculo()
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.guardandoVinculoId = null
      })
    },

    asignarmeChat () {
      if (!this.chat) return
      this.guardandoVinculoId = 'asig'
      this.$http.post('twilio-rh.asignar', {
        idusuarios_wpp: this.chat.idusuarios_wpp,
        usuario: this.chat.usuario,
      }).then(() => {
        this.validarSuccess('Chat asignado')
        return this.recargarChatsRhTrasVinculo()
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.guardandoVinculoId = null
      })
    },

    guardarNombreCandidato (cand) {
      if (!this.puedeGuardarNombre(cand)) return
      const nombre = String(this.nombreEditPorFolio[cand.idformulario] || '').trim()
      this.guardandoNombreId = cand.idformulario
      this.$http.post('twilio-rh.candidato.nombre', {
        idformulario: cand.idformulario,
        nombre_completo: nombre,
      }).then(() => {
        this.aplicarNombreEnChats(cand.idformulario, nombre)
        this.$set(this.nombreEditPorFolio, cand.idformulario, nombre)
        this.validarSuccess('Nombre actualizado')
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.guardandoNombreId = null
      })
    },

    abrirProspectosRh () {
      this.$router.push({ path: '/prospectosrh' })
    },

    abrirEntrevista () {
      const id = this.candidatoSeleccionado && Number(this.candidatoSeleccionado.idformulario)
      if (!id) {
        this.validarErrorDirecto('Vincula un candidato primero')
        return
      }
      this.$router.push({ path: '/entrevistas', query: { idformulario: id } })
    },

    textoResumenDesdeDraft (draft) {
      const d = draft || {}
      const partes = []
      if (d.nombre_completo) {
        let intro = String(d.nombre_completo).trim()
        if (d.edad_aproximada != null) intro += ', ' + d.edad_aproximada + ' años'
        if (d.direccion) intro += '. Reside en ' + d.direccion
        partes.push(intro.endsWith('.') ? intro : intro + '.')
      }
      const edu = (d.educacion || []).map((e) => {
        return [e.titulo, e.institucion, e.periodo].filter(Boolean).join(', ')
      }).filter(Boolean)
      if (edu.length) partes.push('Educación: ' + edu.join('; ') + '.')
      const exp = (d.experiencia_laboral || []).map((e) => {
        const cabeza = [e.puesto, e.empresa, e.periodo].filter(Boolean).join(' — ')
        if (cabeza && e.descripcion) return cabeza + '. ' + e.descripcion
        return e.descripcion || cabeza
      }).filter(Boolean)
      if (exp.length) partes.push('Experiencia: ' + exp.join(' '))
      if (Array.isArray(d.habilidades) && d.habilidades.length) {
        partes.push('Habilidades: ' + d.habilidades.join(', ') + '.')
      }
      if (d.dominio_ingles_texto) partes.push('Inglés: ' + d.dominio_ingles_texto + '.')
      const compuesto = partes.join(' ').replace(/\s+/g, ' ').trim()
      const modelo = String(d.resumen_breve || '').replace(/\s+/g, ' ').trim()
      const palabras = modelo.split(/\s+/).filter(Boolean)
      if (modelo.length >= 80 && palabras.length >= 18) return modelo
      return compuesto || modelo
    },

    cuerpoErrorHttp (error) {
      const d = (error && error.response && error.response.data)
        || (error && error.body)
        || (error && error.data)
        || {}
      if (typeof d === 'string') {
        try { return JSON.parse(d) } catch (_) { return { message: d } }
      }
      return d
    },

    textoErrorAnalisisCv (data) {
      const d = data || {}
      const status = String(d.status || '')
      if (status === 'empty_text' || d.motivo_no_lectura === 'pdf_sin_texto_o_imagen') {
        return 'No se pudo leer el archivo: el PDF no tiene texto seleccionable. Suele ser una foto o captura pegada dentro del PDF. Sin texto no se puede saber si es CV u otro documento, ni armar el resumen. Pide un PDF exportado desde Word, con texto seleccionable.'
      }
      if (status === 'corrupt_or_protected') {
        return 'No se pudo leer el archivo (protegido, dañado o vacío). No se llamó a guardar en ficha.'
      }
      if (status === 'unsupported_format') {
        return 'Formato no soportado para análisis de CV.'
      }
      return String(d.message || '').trim() || 'Error al analizar el CV'
    },

    textoResumenDocumento (doc) {
      const d = doc || {}
      if (String(d.resumen_corto || '').trim()) return String(d.resumen_corto).trim()
      const partes = []
      if (d.tipo_documento) partes.push('Tipo: ' + d.tipo_documento)
      if (d.asunto) partes.push('Asunto: ' + d.asunto)
      if (Array.isArray(d.fechas) && d.fechas.length) partes.push('Fechas: ' + d.fechas.join(', '))
      const campos = (d.campos || [])
        .map((c) => [c.etiqueta, c.valor].filter(Boolean).join(': '))
        .filter(Boolean)
      if (campos.length) partes.push(campos.join('. '))
      return partes.join('. ')
    },

    aplicarFolioDesdeMatch (data) {
      const match = (data && data.match) || {}
      if (match.estado === 'unico' && match.candidato) {
        this.cvIdformulario = match.candidato.idformulario
      } else {
        this.cvIdformulario = null
      }
    },

    draftCvUtilizable (draft) {
      const d = draft || {}
      const tiene = (v) => String(v == null ? '' : v).trim().length > 0
      if (tiene(d.nombre_completo) || tiene(d.correo) || tiene(d.telefono) || tiene(d.resumen_breve)) {
        return true
      }
      if (Array.isArray(d.experiencia_laboral) && d.experiencia_laboral.length) return true
      if (Array.isArray(d.educacion) && d.educacion.length) return true
      return false
    },

    mapInglesCv (texto) {
      const t = String(texto || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim()
      if (!t) return null
      if (/^(no|ningun|none|n\/a)(\b|$)/.test(t)) return 0
      return 1
    },

    resetAnalizarCv () {
      this.cvAnalizando = false
      this.cvGuardando = false
      this.cvDecidiendo = false
      this.cvDecisionLocal = ''
      this.cvSucursalElegida = null
      this.cvIdmensajes = null
      this.cvResult = null
      this.cvError = ''
      this.cvResumen = ''
      this.cvIdformulario = null
      this.cvTelefonoCv = ''
      this.cvEdit = {
        nombre_completo: '',
        correo: '',
        edad: '',
        direccion: '',
        dominio_ingles: null,
      }
    },

    letraInciso (i) {
      return String.fromCharCode(97 + (Number(i) || 0))
    },

    textoTiempoSucursal (suc) {
      if (!suc) return ''
      const km = suc.distancia_km != null ? suc.distancia_km + ' km' : ''
      if (suc.minutos != null && suc.duracion_texto) {
        return suc.leyenda + ': ' + suc.duracion_texto + (km ? ' · ' + km : '')
      }
      return suc.leyenda || km || 'Sin tiempo calculado'
    },

    cerrarAnalizarCv () {
      this.dialogCvAnalizar = false
      this.resetAnalizarCv()
    },

    decidirCv (decision) {
      if (!this.cvIdmensajes || this.cvDecidiendo) return
      this.cvDecidiendo = true
      const payload = { idmensajes: this.cvIdmensajes, decision }
      if (decision === 'aceptar' && this.cvSucursalElegida) payload.idplantel = this.cvSucursalElegida
      this.$http.post('twilio-rh.cv.decision', payload).then(() => {
        this.cvDecisionLocal = decision
        this.validarSuccess(decision === 'aceptar'
          ? 'Sucursal elegida. El flujo continúa en el chat.'
          : 'Se envió el mensaje de cierre.')
        if (this.chat) this.verChat(this.chat)
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.cvDecidiendo = false
      })
    },

    abrirAnalizarCv (mensaje) {
      const id = mensaje && Number(mensaje.idmensajes)
      if (!id) {
        this.validarErrorDirecto('No se pudo identificar el adjunto')
        return
      }
      this.resetAnalizarCv()
      this.cvIdmensajes = id
      this.dialogCvAnalizar = true
      this.cvAnalizando = true
      this.$http.post('twilio-rh.cv.analizar', { idmensajes: id }).then((response) => {
        const data = response.data || response.body || {}
        if (!data.ok) {
          this.cvError = this.textoErrorAnalisisCv(data)
          this.cvResult = data
          return
        }
        this.cvResult = data
        this.aplicarFolioDesdeMatch(data)
        if (data.tipo === 'documento') {
          this.cvResumen = this.textoResumenDocumento(data.documento)
          return
        }
        if (!this.draftCvUtilizable(data.draft)) {
          this.cvResumen = ''
          return
        }
        this.cvResumen = this.textoResumenDesdeDraft(data.draft)
        const draft = data.draft || {}
        this.cvTelefonoCv = draft.telefono || ''
        const revision = data.revision_cv || {}
        const edadCv = revision.edad != null ? revision.edad : draft.edad_aproximada
        this.cvEdit = {
          nombre_completo: draft.nombre_completo || '',
          correo: draft.correo || '',
          edad: edadCv != null ? edadCv : '',
          direccion: revision.direccion_completa || draft.direccion || '',
          dominio_ingles: this.mapInglesCv(draft.dominio_ingles_texto),
        }
        const sucs = (data.sucursales_cercanas && data.sucursales_cercanas.items) || []
        if (sucs.length === 1) this.cvSucursalElegida = sucs[0].idplantel
      }).catch((error) => {
        this.cvError = this.textoErrorAnalisisCv(this.cuerpoErrorHttp(error))
      }).finally(() => {
        this.cvAnalizando = false
      })
    },

    guardarResumenCv () {
      if (!this.puedeGuardarAdjunto) return
      this.cvGuardando = true
      this.$http.post('twilio-rh.cv.guardar-resumen', {
        idformulario: this.cvIdformulario,
        resumen: String(this.cvResumen || '').trim(),
        idmensajes: this.cvIdmensajes,
        tipo: this.esAnalisisDocumento ? 'documento' : 'cv',
        telefono_cv: this.esAnalisisDocumento ? '' : this.cvTelefonoCv,
        confirmado: this.esAnalisisDocumento ? {} : {
          nombre_completo: this.cvEdit.nombre_completo,
          correo: this.cvEdit.correo,
          edad: this.cvEdit.edad,
          direccion: this.cvEdit.direccion,
          dominio_ingles: this.cvEdit.dominio_ingles,
        },
      }).then(() => {
        this.validarSuccess(this.esAnalisisDocumento
          ? 'Resumen del documento guardado en comentarios.'
          : 'Ficha actualizada. El teléfono del CV quedó en comentarios.')
        this.cerrarAnalizarCv()
        this.recargarChats()
      }).catch((error) => {
        const body = (error && error.body) || (error && error.data) || {}
        if (body.status === 'ya_aplicado' || (error && error.status === 409)) {
          this.validarErrorDirecto(body.message || 'Este adjunto ya se aplicó a la ficha.')
          return
        }
        this.validarError(error)
      }).finally(() => {
        this.cvGuardando = false
      })
    },

    cargarReclutadorasRh () {
      if (this.reclutadorasRh.length) return Promise.resolve()
      return this.$http.get('reclutadoras').then((response) => {
        const rows = Array.isArray(response.data) ? response.data : []
        this.reclutadorasRh = rows.map((r) => ({
          iderp: Number(r.iderp || r.idusuarios || r.id_usuario || 0),
          nombre: r.nombre || r.nombre_completo || r.name || r.reclutadora || ('Usuario ' + (r.iderp || '')),
        })).filter((r) => r.iderp)
      }).catch((error) => {
        this.validarError(error)
      })
    },

    seleccionarFiltroReclutador (item) {
      if (!item || item.todos) {
        this.filtroReclutador = null
        return
      }
      this.filtroReclutador = item
    },

    reclutadorMenuActivo (item) {
      if (!item) return false
      if (item.todos) return !this.filtroReclutador
      if (!this.filtroReclutador) return false
      if (item.sinAsignar) return !!this.filtroReclutador.sinAsignar
      return Number(this.filtroReclutador.iderp) === Number(item.iderp)
    },

    chatEstaSeleccionado (chatW) {
      if (!chatW || !chatW.usuario) return false
      return (this.chatsSeleccionados || []).some((c) => c && c.usuario === chatW.usuario)
    },

    toggleSeleccionChat (chatW) {
      if (!chatW || !chatW.usuario) return
      if (this.chatEstaSeleccionado(chatW)) {
        this.chatsSeleccionados = this.chatsSeleccionados.filter((c) => c && c.usuario !== chatW.usuario)
        return
      }
      this.chatsSeleccionados = this.chatsSeleccionados.concat([chatW])
    },

    abrirReasignacionMasiva () {
      if (!this.chatsSeleccionados.length) {
        this.validarErrorDirecto('Selecciona al menos un chat en la lista')
        return
      }
      this.reasignacionMasiva = true
      this.dialogReasignarRh = true
      this.cargarReclutadorasRh()
    },

    abrirReasignarRh () {
      this.reasignacionMasiva = false
      this.dialogReasignarRh = true
      this.cargarReclutadorasRh()
    },

    guardarReasignarRh () {
      const chats = this.reasignacionMasiva
        ? (this.chatsSeleccionados || []).slice()
        : (this.chat && this.chat.usuario ? [this.chat] : [])
      if (!chats.length || !this.iderpReasignar) return
      this.guardandoReasignar = true
      const iderp = this.iderpReasignar
      let ok = 0
      let fail = 0
      const siguiente = (i) => {
        if (i >= chats.length) {
          this.guardandoReasignar = false
          this.dialogReasignarRh = false
          this.reasignacionMasiva = false
          this.chatsSeleccionados = []
          if (fail && ok) {
            this.validarErrorDirecto(ok + ' reasignados. ' + fail + ' no se pudieron reasignar.')
          } else if (fail) {
            this.validarErrorDirecto('No se pudo reasignar')
          } else if (ok === 1) {
            this.validarSuccess('Reclutadora actualizada')
          } else {
            this.validarSuccess(ok + ' contactos reasignados')
          }
          this.recargarChats()
          return
        }
        const chat = chats[i]
        this.$http.post('twilio-rh.asignar', {
          usuario: chat.usuario,
          iderpResponsable: iderp,
          idpuesto: chat.vinculo && chat.vinculo.idpuesto_proceso,
        }).then(() => {
          ok += 1
        }).catch(() => {
          fail += 1
        }).then(() => {
          siguiente(i + 1)
        })
      }
      siguiente(0)
    },

    abrirNotasFicha () {
      const id = this.idFichaChat
      if (!id) return
      this.comentariosFicha = []
      this.dialogNotasFicha = true
      this.$http.get('formulario.datos/' + id).then((response) => {
        this.comentariosFicha = (response.data && response.data.comentarios) || []
      }).catch((error) => {
        this.validarError(error)
      })
    },

    addComentarioFicha (mensaje) {
      const id = this.idFichaChat
      const texto = String(mensaje || '').trim()
      if (!id || !texto) return
      const etapa = this.chat && this.chat.candidato ? this.chat.candidato.etapa : 0
      this.$http.post('formularios.comentarios', {
        idformularios: id,
        idusuarioerp: this.getdatosUsuarioERPERP.iderp,
        comentario: texto,
        etapa: etapa || 0,
      }).then(() => {
        this.abrirNotasFicha()
      }).catch((error) => {
        this.validarError(error)
      })
    },

    descargarUltimos100Json () {
      if (!this.puedeDescargarJsonRh) return
      const chats = (this.allChats || [])
        .slice()
        .sort((a, b) => fechaUltimoMensajeMs(b) - fechaUltimoMensajeMs(a))
        .slice(0, 100)
      const payload = {
        generado: new Date().toISOString(),
        total: chats.length,
        chats,
      }
      const blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = 'twilio-rh-ultimos-100.json'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },

    recargarChats () {
      if (!this.numeroTwilioRh) {
        this.allChats = []
        return Promise.resolve()
      }

      this.cargar = true
      return this.$http.post('twilio-rh.chats', {}).then((response) => {
        const chats = ((response.data && response.data.chats) || []).map((c) => Object.assign({}, c))
        this.conteoTiempos(chats)
        this.allChats = chats
        this.guardarConversacionesUnif(chats)
        if (response.data && response.data.twilio) {
          this.numeroTwilioRh = response.data.twilio
        }
        this.esAdminRh = Boolean(response.data && response.data.esAdmin)
        this.reenlazarChatAbierto(chats)
      }).catch((error) => {
        let msg = 'Error al cargar chats RH'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally(() => {
        this.cargar = false
      })
    },

    reenlazarChatAbierto (chats) {
      if (!this.chat || !this.chat.usuario) return
      const fresh = (chats || []).find((c) => c && c.usuario === this.chat.usuario)
      if (!fresh) return
      this.chat = Object.assign({}, this.chat, {
        match_estado: fresh.match_estado,
        candidato: fresh.candidato,
        candidatos: fresh.candidatos,
        vinculo: fresh.vinculo,
        reclutador: fresh.reclutador || null,
        idetiquetas: fresh.idetiquetas,
        nombre: fresh.nombre || this.chat.nombre,
        entrevista: fresh.entrevista,
        requiere_humana: fresh.requiere_humana,
        cv_filtro: fresh.cv_filtro,
        cv_filtro_texto: fresh.cv_filtro_texto,
      })
    },

    /** Actualiza solo lista RH local; no toca stores de Unificado/Fast. */
    validayGuardaMensajesRh (payload = {}) {
      if (!this.chat || !this.chat.usuario) return
      const texto = payload && payload.mensaje != null ? payload.mensaje : ''
      const fecha = payload && payload.fecha_ultimo_mensaje
        ? payload.fecha_ultimo_mensaje
        : new Date().toISOString().replace('T', ' ').slice(0, 19)

      const conversaciones = (this.allChats || []).slice()
      for (let i = 0; i < conversaciones.length; i++) {
        if (conversaciones[i].usuario == this.chat.usuario) {
          if (texto !== '') {
            conversaciones[i].ultimomensaje = texto
            conversaciones[i].mensaje = texto
          }
          conversaciones[i].sinleer = 0
          conversaciones[i].mio = 1
          conversaciones[i].fecha_ultimo_mensaje = fecha
        }
      }
      this.allChats = conversaciones
      this.$set(this.chat, 'sinleer', 0)
      this.$set(this.chat, 'mio', 1)
      if (texto !== '') {
        this.$set(this.chat, 'ultimomensaje', texto)
        this.$set(this.chat, 'mensaje', texto)
      }
      this.$set(this.chat, 'fecha_ultimo_mensaje', fecha)
    },

    wa10De (valor) {
      return String(valor || '').replace(/\D/g, '').slice(-10)
    },

    chatEstaActivo (chatW) {
      if (!this.chat || !chatW) return false
      const a = this.wa10De(this.chat.usuario)
      const b = this.wa10De(chatW.usuario)
      if (a && b && a.length === 10 && b.length === 10) return a === b
      return String(this.chat.usuario || '') === String(chatW.usuario || '')
    },

    enfocarChatActivoEnLista () {
      this.$nextTick(() => {
        const ref = this.$refs.chatActivoFila
        const el = Array.isArray(ref) ? ref[0] : ref
        const nodo = el && el.$el ? el.$el : el
        if (nodo && nodo.scrollIntoView) {
          nodo.scrollIntoView({ block: 'nearest' })
        }
      })
    },

    formatearNombreRh (nombreCompleto) {
      return String(nombreCompleto || '')
        .trim()
        .toLowerCase()
        .split(/\s+/)
        .filter(Boolean)
        .map((palabra) => palabra.charAt(0).toUpperCase() + palabra.slice(1))
        .join(' ')
    },

    telefonoListaChat (chatW) {
      return String((chatW && chatW.usuario) || '').replace('whatsapp:+52', '')
    },

    nombreReclutadorChat (chatW) {
      const raw = chatW && chatW.reclutador && chatW.reclutador.nombre
      if (!raw) return ''
      return this.formatearNombreRh(raw)
    },

    nombreCandidatoChat (chatW) {
      if (!chatW) return ''
      const estado = chatW.match_estado
      if ((estado === 'unico' || estado === 'vinculado') && chatW.candidato && String(chatW.candidato.nombre_completo || '').trim()) {
        return String(chatW.candidato.nombre_completo).trim()
      }
      if (chatW.nombre && String(chatW.nombre).trim()) return String(chatW.nombre).trim()
      return ''
    },

    tituloContactoChat (chatW) {
      return this.nombreCandidatoChat(chatW) || this.telefonoListaChat(chatW) || 'Sin nombre'
    },

    tituloListaChat (chatW) {
      const rec = this.nombreReclutadorChat(chatW)
      if (rec) return rec
      return this.tituloContactoChat(chatW)
    },

    subtituloListaChat (chatW) {
      if (!chatW) return ''
      const rec = this.nombreReclutadorChat(chatW)
      const cand = this.nombreCandidatoChat(chatW)
      const tel = this.telefonoListaChat(chatW)
      if (rec) {
        if (cand && tel) return cand + ' · ' + tel
        return cand || tel
      }
      if (cand && tel && cand !== tel) return tel
      return ''
    },

    resumenMensaje (chatW) {
      if (!chatW) return ''
      const texto = chatW.ultimmensaje || chatW.ultimomensaje || chatW.mensaje || ''
      if (!texto) return 'Sin mensajes'
      return String(texto).length > 42 ? String(texto).slice(0, 42) + '…' : texto
    },

    horaChat (chatW) {
      const ms = fechaUltimoMensajeMs(chatW)
      if (!ms) return ''
      const fecha = formatFechaMexicoFront(ms)
      const diaMsg = fecha.slice(0, 10)
      const diaHoy = formatFechaMexicoFront(Date.now()).slice(0, 10)
      if (diaMsg === diaHoy) return fecha.slice(11, 16)
      const partes = diaHoy.split('-')
      const ayerDate = new Date(Date.UTC(Number(partes[0]), Number(partes[1]) - 1, Number(partes[2])))
      ayerDate.setUTCDate(ayerDate.getUTCDate() - 1)
      const p = (n) => String(n).padStart(2, '0')
      const diaAyer = ayerDate.getUTCFullYear() + '-' + p(ayerDate.getUTCMonth() + 1) + '-' + p(ayerDate.getUTCDate())
      if (diaMsg === diaAyer) return 'Ayer'
      return diaMsg.slice(8, 10) + '/' + diaMsg.slice(5, 7)
    },

    cerrarChatMobile () {
      this.chat = null
      this.mensajes = []
      this.dialogCandidato = false
    },

    /** Horas que faltan para cumplir 24 h desde el último mensaje del postulante. */
    calcularTiempoRestanteRh (chat) {
      if (!chat) return 0
      if (chat.tiemporestante != null && chat.tiemporestante !== '') {
        return Number(chat.tiemporestante)
      }
      const raw = chat.fecha_ultimo_mensaje_cliente || chat.fecha_ultimo_mensaje
      if (!raw) return 0
      const d = new Date(raw)
      if (isNaN(d.getTime())) return 0
      const horas = (Date.now() - d.getTime()) / 3600000
      return Math.max(-24, Math.floor(24 - horas))
    },

    aplicarFiltroHumanaQuery () {
      const h = this.$route.query && this.$route.query.humana
      if (h === '1' || h === 'true') this.filtroHumana = true
    },

    abrirChatDesdeQuery () {
      const wa = String((this.$route.query && this.$route.query.wa) || '').replace(/\D/g, '').slice(-10)
      if (!wa || wa.length !== 10) return
      const actual = this.chat && this.chat.usuario
        ? String(this.chat.usuario).replace(/\D/g, '').slice(-10)
        : ''
      if (actual === wa) return
      const chat = (this.allChats || []).find((c) => {
        return String((c && c.usuario) || '').replace(/\D/g, '').slice(-10) === wa
      })
      if (chat) {
        this.verChat(chat)
        return
      }
      this.verChat({
        usuario: 'whatsapp:+521' + wa,
        nombre: wa,
      })
    },

    verChat (chat) {
      if (!this.numeroTwilioRh || !chat || !chat.usuario) {
        this.chat = Object.assign({}, chat || {}, { numeroTwilio: this.numeroTwilioRh || '' })
        this.mensajes = []
        return
      }

      const payload = {
        usuario: chat.usuario,
      }

      this.cargar = true
      this.mensajes = []
      this.chat = Object.assign({}, chat, { numeroTwilio: this.numeroTwilioRh || chat.numeroTwilio })
      const idxActivo = (this.filterChats || []).findIndex((c) => this.chatEstaActivo(c))
      if (idxActivo > this.limite) this.limite = idxActivo
      chat.numeroTwilio = this.numeroTwilioRh
      chat.tiemporestante = this.calcularTiempoRestanteRh(chat)

      return this.$http.post('twilio-rh.mensajes', payload).then((response) => {
        this.mensajes = response.data.conversacionCompleta || []
        this.analysisIA = {}

        const conversaciones = this.allChats.slice()
        for (let i = 0; i < conversaciones.length; i++) {
          if (conversaciones[i].usuario == chat.usuario) {
            conversaciones[i].sinleer = 0
            if (conversaciones[i].tiemporestante == null) {
              conversaciones[i].tiemporestante = chat.tiemporestante
            }
          }
        }

        this.chat = Object.assign({}, chat)
        const actualizado = this.allChats.find((c) => c.usuario === chat.usuario)
        if (actualizado) {
          this.chat.match_estado = actualizado.match_estado
          this.chat.candidato = actualizado.candidato
          this.chat.candidatos = actualizado.candidatos
          if (actualizado.nombre) this.chat.nombre = actualizado.nombre
        }
        this.allChats = conversaciones
        this.guardarConversacionesUnif(conversaciones)

        setTimeout(function () {
          const el = document.getElementById('scroll-target')
          if (el) el.scrollTop = el.scrollHeight
        }, 300)
      }).catch((error) => {
        let msg = 'Error al cargar el chat RH'
        if (error && error.response && error.response.data && error.response.data.message) {
          msg = error.response.data.message
        }
        this.validarError(msg)
      }).finally(() => {
        this.cargar = false
      })
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/twilio-whatsapp-layout.scss';

.wa-contact.wa-contact-active,
.wa-contact.wa-contact-active:hover {
  background: #c8efe4 !important;
  box-shadow: inset 0 0 0 1px rgba(0, 168, 132, 0.35);
}

.textoPoppins {
  font-family: 'Poppins', sans-serif !important;
}

.twilio-rh-sidebar-header {
  flex: 0 0 64px;
  height: 64px;
  min-height: 64px;
  position: relative;
  z-index: 2;
}

.twilio-rh-header-title {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.wa-contact-check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 28px;
  cursor: pointer;
}

.wa-contact-checked {
  background: #e7f8f2 !important;
}

.twilio-rh-reclutadores-menu {
  min-width: 440px;
  max-width: 560px;
  max-height: 420px;
  overflow-y: auto;
}

.twilio-rh-list-stack {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

@media (max-width: 599px) {
  .twilio-rh-sidebar-chat {
    height: auto !important;
    flex: 0 0 auto !important;
    z-index: 7;
    position: relative;
    background: #f0f2f5;
  }

  .twilio-whatsapp-row > .twilio-whatsapp-conversation:not(.wa-panel-hidden) {
    top: calc(128px + env(safe-area-inset-top, 0px));
    height: calc(100dvh - 128px - env(safe-area-inset-top, 0px)) !important;
    max-height: calc(100dvh - 128px - env(safe-area-inset-top, 0px)) !important;
    padding-top: 0;
    z-index: 4;
  }
}

.twilio-whatsapp-shell.container {
  max-width: none;
  padding: 0;
  margin: 0;
  height: calc(100vh - 64px);
  height: calc(100dvh - 64px - env(safe-area-inset-top, 0px));
  background: transparent;
  box-shadow: none;
}

.wa-messages-scroll.container {
  max-width: none;
  background: transparent;
  box-shadow: none;
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  margin-top: 0;
  padding: 8px 12px 16px;
}

.wa-rh-chip {
  font-size: 10px;
  font-weight: 600;
  border-radius: 8px;
  padding: 1px 6px;
  margin-right: 4px;
}
.wa-rh-chip--ok {
  background: #d9fdd3;
  color: #1b5e20;
}
.wa-rh-chip--warn {
  background: #fff3cd;
  color: #7a5d00;
}
.wa-rh-chip--muted {
  background: #e9edef;
  color: #3b4a54;
}
.wa-rh-chip--info {
  background: #d0ebff;
  color: #0b4f8a;
}
.wa-rh-chip--bad {
  background: #fde8e8;
  color: #8a1f1f;
}
.wa-rh-chip--previa,
.wa-rh-chip--solid {
  background: #5e35b1;
  color: #fff;
}

.wa-rh-chips-row {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 4px;
}

.twilio-rh-panel__empty {
  font-size: 13px;
  color: #667781;
  line-height: 1.4;
  margin-bottom: 8px;
}

.twilio-rh-cand {
  border: 1px solid #e9edef;
  border-radius: 8px;
  padding: 10px;
  margin-bottom: 10px;
}

.twilio-rh-cand__name {
  font-weight: 600;
  color: #111b21;
  font-size: 14px;
}

.twilio-rh-cand__row {
  font-size: 13px;
  color: #3b4a54;
  margin-top: 2px;
}

.twilio-rh-cand-actions {
  padding: 8px 12px 12px;
}

.wrap-criterio {
  white-space: normal;
  overflow: visible;
  text-overflow: unset;
}

.leyenda-puntaje {
  font-size: 12px;
  color: #546e7a;
  display: inline-flex;
  align-items: center;
}

.leyenda-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 4px;
}

.leyenda-dot.green { background: #4caf50; }
.leyenda-dot.orange { background: #fb8c00; }
.leyenda-dot.red { background: #e53935; }
</style>
